var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _path2, _path3, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _path4, _path5, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _g39, _path144, _path145, _g40, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _g41, _g42, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _path272, _g53, _g54, _g55, _g56, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _g57, _g58, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentAnalystUseCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 265,
    height: 191,
    viewBox: "0 0 265 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2826 58.0605L61.2909 72.3196L25.0076 93.2763L0 79.0172L36.2826 58.0605Z",
    fill: "url(#paint0_linear_2723_72924)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2271 59.2676L23.7263 65.915L12.2256 72.5578L0.725586 65.9104L12.2271 59.2676Z",
    fill: "url(#paint1_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7363 79.1138L12.2295 85.7566V72.553L23.7363 65.9102V79.1138Z",
    fill: "url(#paint2_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2316 85.7566L0.725586 79.1138V65.9102L12.2316 72.553V85.7566Z",
    fill: "url(#paint3_linear_2723_72924)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2271 45.5625L23.7263 52.2099L12.2256 58.8527L0.725586 52.2053L12.2271 45.5625Z",
    fill: "url(#paint4_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7363 65.4087L12.2295 72.0523V58.8487L23.7363 52.2051V65.4087Z",
    fill: "url(#paint5_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2316 72.0523L0.725586 65.4087V52.2051L12.2316 58.8487V72.0523Z",
    fill: "url(#paint6_linear_2723_72924)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2271 31.8574L23.7263 38.5048L12.2256 45.1477L0.725586 38.5003L12.2271 31.8574Z",
    fill: "url(#paint7_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7363 51.7036L12.2295 58.3465V45.1428L23.7363 38.5V51.7036Z",
    fill: "url(#paint8_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2316 58.3465L0.725586 51.7036V38.5L12.2316 45.1428V58.3465Z",
    fill: "url(#paint9_linear_2723_72924)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2279 35.3535L20.6915 40.2464L12.2272 45.1354L3.76367 40.2426L12.2279 35.3535Z",
    fill: "url(#paint10_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6983 49.9614L12.2295 54.8505V45.1332L20.6983 40.2441V49.9614Z",
    fill: "url(#paint11_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2315 54.8505L3.7627 49.9614V40.2441L12.2315 45.1332V54.8505Z",
    fill: "url(#paint12_linear_2723_72924)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2271 18.1523L23.7263 24.7997L12.2256 31.4426L0.725586 24.7952L12.2271 18.1523Z",
    fill: "url(#paint13_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7363 37.9985L12.2295 44.6421V31.4385L23.7363 24.7949V37.9985Z",
    fill: "url(#paint14_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2316 44.6421L0.725586 37.9985V24.7949L12.2316 31.4385V44.6421Z",
    fill: "url(#paint15_linear_2723_72924)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2271 4.44531L23.7263 11.0935L12.2256 17.7356L0.725586 11.0882L12.2271 4.44531Z",
    fill: "url(#paint16_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7363 24.2908L12.2295 30.9344V17.7307L23.7363 11.0879V24.2908Z",
    fill: "url(#paint17_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2316 30.9344L0.725586 24.2908V11.0879L12.2316 17.7307V30.9344Z",
    fill: "url(#paint18_linear_2723_72924)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2097 66.2012L35.7089 72.8486L24.2082 79.4914L12.709 72.844L24.2097 66.2012Z",
    fill: "url(#paint19_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7187 86.0493L24.2119 92.6922V79.4885L35.7187 72.8457V86.0493Z",
    fill: "url(#paint20_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2141 92.6922L12.708 86.0493V72.8457L24.2141 79.4885V92.6922Z",
    fill: "url(#paint21_linear_2723_72924)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2097 11.3789L35.7089 18.0263L24.2082 24.6692L12.709 18.0217L24.2097 11.3789Z",
    fill: "url(#paint22_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7187 31.2271L24.2119 37.8707V24.667L35.7187 18.0234V31.2271Z",
    fill: "url(#paint23_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2141 37.8707L12.708 31.2271V18.0234L24.2141 24.667V37.8707Z",
    fill: "url(#paint24_linear_2723_72924)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2104 14.877L32.6739 19.7698L24.2096 24.6581L15.7461 19.766L24.2104 14.877Z",
    fill: "url(#paint25_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.681 29.4837L24.2129 34.3727V24.6554L32.681 19.7656V29.4837Z",
    fill: "url(#paint26_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.214 34.3727L15.7451 29.4837V19.7656L24.214 24.6554V34.3727Z",
    fill: "url(#paint27_linear_2723_72924)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.2234 73.125L47.7226 79.7724L36.2219 86.4153L24.7227 79.7678L36.2234 73.125Z",
    fill: "url(#paint28_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7217 92.9731V79.7695L36.2285 86.4124L24.7217 92.9731Z",
    fill: "url(#paint29_linear_2723_72924)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.2234 59.418L47.7226 66.0654L36.2219 72.7082L24.7227 66.0608L36.2234 59.418Z",
    fill: "url(#paint30_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7324 79.2642L36.2256 85.9078V72.7041L47.7324 66.0605V79.2642Z",
    fill: "url(#paint31_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2285 85.9078L24.7217 79.2642V66.0605L36.2285 72.7041V85.9078Z",
    fill: "url(#paint32_linear_2723_72924)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.2234 45.7129L47.7226 52.3603L36.2219 59.0031L24.7227 52.3557L36.2234 45.7129Z",
    fill: "url(#paint33_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7324 65.5591L36.2256 72.2019V58.9983L47.7324 52.3555V65.5591Z",
    fill: "url(#paint34_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2285 72.2019L24.7217 65.5591V52.3555L36.2285 58.9983V72.2019Z",
    fill: "url(#paint35_linear_2723_72924)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.2234 32.0059L47.7226 38.6533L36.2219 45.2961L24.7227 38.6487L36.2234 32.0059Z",
    fill: "url(#paint36_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7324 51.8521L36.2256 58.4957V45.292L47.7324 38.6484V51.8521Z",
    fill: "url(#paint37_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2285 58.4957L24.7217 51.8521V38.6484L36.2285 45.292V58.4957Z",
    fill: "url(#paint38_linear_2723_72924)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.2285 44.7918L24.7217 38.1482V24.9453L36.2285 31.5882V44.7918Z",
    fill: "url(#paint39_linear_2723_72924)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.2232 18.3008L24.7217 24.9429L36.2262 44.7901L47.7323 38.1465L36.2232 18.3008Z",
    fill: "url(#paint40_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2285 44.7898L24.7217 38.1462V24.9434L36.2285 44.7898Z",
    fill: "url(#paint41_linear_2723_72924)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3482 58.6445L12.0215 72.8603L24.3307 79.5936L12.7525 72.3732L12.3482 58.6445Z",
    fill: "url(#paint42_radial_2723_72924)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2836 89.6191L53.001 110.576L65.2502 117.656L76.8649 110.948L88.9454 117.931L77.3307 124.64L89.2798 131.548L125.563 110.591L89.2836 89.6191Z",
    fill: "url(#paint43_linear_2723_72924)"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.2281 90.8281L76.7273 97.4755L65.2265 104.118L53.7266 97.471L65.2281 90.8281Z",
    fill: "url(#paint44_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7373 110.674L65.2305 117.318V104.114L76.7373 97.4707V110.674Z",
    fill: "url(#paint45_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2326 117.318L53.7266 110.674V97.4707L65.2326 104.114V117.318Z",
    fill: "url(#paint46_linear_2723_72924)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.2281 77.123L76.7273 83.7705L65.2265 90.4133L53.7266 83.7659L65.2281 77.123Z",
    fill: "url(#paint47_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7373 96.9712L65.2305 103.614V90.4104L76.7373 83.7676V96.9712Z",
    fill: "url(#paint48_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2326 103.614L53.7266 96.9712V83.7676L65.2326 90.4104V103.614Z",
    fill: "url(#paint49_linear_2723_72924)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.2281 63.416L76.7273 70.0634L65.2265 76.7063L53.7266 70.0589L65.2281 63.416Z",
    fill: "url(#paint50_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7373 83.2622L65.2305 89.9058V76.7022L76.7373 70.0586V83.2622Z",
    fill: "url(#paint51_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2326 89.9058L53.7266 83.2622V70.0586L65.2326 76.7022V89.9058Z",
    fill: "url(#paint52_linear_2723_72924)"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.2289 66.9141L73.6924 71.8062L65.2282 76.6952L56.7646 71.8031L65.2289 66.9141Z",
    fill: "url(#paint53_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6993 81.5208L65.2305 86.4099V76.6918L73.6993 71.8027V81.5208Z",
    fill: "url(#paint54_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2325 86.4099L56.7637 81.5208V71.8027L65.2325 76.6918V86.4099Z",
    fill: "url(#paint55_linear_2723_72924)"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.2281 49.7129L76.7273 56.3611L65.2265 63.0039L53.7266 56.3565L65.2281 49.7129Z",
    fill: "url(#paint56_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7373 69.5603L65.2305 76.2039V63.0003L76.7373 56.3574V69.5603Z",
    fill: "url(#paint57_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2326 76.2039L53.7266 69.5603V56.3574L65.2326 63.0003V76.2039Z",
    fill: "url(#paint58_linear_2723_72924)"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.7373 55.8521L65.2305 62.4957V49.2913L76.7373 42.6484V55.8521Z",
    fill: "url(#paint59_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2326 62.4954L53.7266 55.8518L65.2326 49.291V62.4954Z",
    fill: "url(#paint60_linear_2723_72924)"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.2107 42.9395L88.7099 49.5869L77.2092 56.2297L65.71 49.5823L77.2107 42.9395Z",
    fill: "url(#paint61_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7197 62.7857L77.2129 69.4285V56.2249L88.7197 49.582V62.7857Z",
    fill: "url(#paint62_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2151 69.4285L65.709 62.7857V49.582L77.2151 56.2249V69.4285Z",
    fill: "url(#paint63_linear_2723_72924)"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.2113 46.4355L85.6749 51.3284L77.2106 56.2174L68.7471 51.3246L77.2113 46.4355Z",
    fill: "url(#paint64_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6819 61.0435L77.2139 65.9333V56.2152L85.6819 51.3262V61.0435Z",
    fill: "url(#paint65_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2149 65.9333L68.7461 61.0435V51.3262L77.2149 56.2152V65.9333Z",
    fill: "url(#paint66_linear_2723_72924)"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.2244 104.684L100.724 111.331L89.2228 117.974L77.7236 111.326L89.2244 104.684Z",
    fill: "url(#paint67_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.733 124.53L89.2266 131.173V117.97L100.733 111.326V124.53Z",
    fill: "url(#paint68_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2295 131.173L77.7227 124.53V111.326L89.2295 117.97V131.173Z",
    fill: "url(#paint69_linear_2723_72924)"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.2244 90.9785L100.724 97.6259L89.2228 104.269L77.7236 97.6214L89.2244 90.9785Z",
    fill: "url(#paint70_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.733 110.825L89.2266 117.468V104.264L100.733 97.6211V110.825Z",
    fill: "url(#paint71_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2295 117.468L77.7227 110.825V97.6211L89.2295 104.264V117.468Z",
    fill: "url(#paint72_linear_2723_72924)"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.2244 77.2734L100.724 83.9208L89.2228 90.5637L77.7236 83.9163L89.2244 77.2734Z",
    fill: "url(#paint73_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.733 97.1196L89.2266 103.763V90.5596L100.733 83.916V97.1196Z",
    fill: "url(#paint74_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2295 103.763L77.7227 97.1196V83.916L89.2295 90.5596V103.763Z",
    fill: "url(#paint75_linear_2723_72924)"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.2244 63.5684L100.724 70.2158L89.2228 76.8586L77.7236 70.2104L89.2244 63.5684Z",
    fill: "url(#paint76_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.733 83.4165L89.2266 90.0594V76.8557L100.733 70.2129V83.4165Z",
    fill: "url(#paint77_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2295 90.0594L77.7227 83.4165V70.2129L89.2295 76.8557V90.0594Z",
    fill: "url(#paint78_linear_2723_72924)"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.2241 49.8613L77.7227 56.5042L89.2272 76.3506L100.733 69.7078L89.2241 49.8613Z",
    fill: "url(#paint79_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2295 76.3504L77.7227 69.7075V56.5039L89.2295 76.3504Z",
    fill: "url(#paint80_linear_2723_72924)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9619 49.8984L77.4786 55.9129L88.9725 49.8984L78.1435 56.6727L89.7316 76.9045L89.4824 131.49L89.1617 76.8095L77.5736 56.8627L65.9619 49.8984Z",
    fill: "url(#paint81_radial_2723_72924)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M155.126 128.186L166.962 135.099L130.679 156.056L118.843 149.142L155.126 128.186Z",
    fill: "url(#paint82_linear_2723_72924)"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.61 67.4473L130.11 74.0947L118.609 80.7383L107.109 74.0901L118.61 67.4473Z",
    fill: "url(#paint83_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.119 87.2942L118.613 93.9371V80.7335L130.119 74.0898V87.2942Z",
    fill: "url(#paint84_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.615 93.9371L107.108 87.2942V74.0898L118.615 80.7335V93.9371Z",
    fill: "url(#paint85_linear_2723_72924)"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.611 70.9434L127.075 75.8362L118.61 80.7253L110.146 75.8324L118.611 70.9434Z",
    fill: "url(#paint86_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.082 85.5501L118.613 90.4391V80.7218L127.082 75.832V85.5501Z",
    fill: "url(#paint87_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.615 90.4391L110.146 85.5501V75.832L118.615 80.7218V90.4391Z",
    fill: "url(#paint88_linear_2723_72924)"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.563 74.3828L142.062 81.0302L130.562 87.6731L119.062 81.0256L130.563 74.3828Z",
    fill: "url(#paint89_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.072 94.229L130.565 100.872V87.6682L142.072 81.0254V94.229Z",
    fill: "url(#paint90_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.568 100.872L119.062 94.229V81.0254L130.568 87.6682V100.872Z",
    fill: "url(#paint91_linear_2723_72924)"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.624 129.193L142.124 135.841L130.623 142.484L119.123 135.836L130.624 129.193Z",
    fill: "url(#paint92_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.133 149.04L130.627 155.683V142.48L142.133 135.836V149.04Z",
    fill: "url(#paint93_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.629 155.683L119.122 149.04V135.836L130.629 142.48V155.683Z",
    fill: "url(#paint94_linear_2723_72924)"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.624 115.488L142.124 122.136L130.623 128.779L119.123 122.131L130.624 115.488Z",
    fill: "url(#paint95_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.133 135.334L130.627 141.977V128.774L142.133 122.131V135.334Z",
    fill: "url(#paint96_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.629 141.977L119.122 135.334V122.131L130.629 128.774V141.977Z",
    fill: "url(#paint97_linear_2723_72924)"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.624 101.781L142.124 108.429L130.623 115.072L119.123 108.424L130.624 101.781Z",
    fill: "url(#paint98_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.133 121.627L130.627 128.27V115.067L142.133 108.424V121.627Z",
    fill: "url(#paint99_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.629 128.27L119.122 121.627V108.424L130.629 115.067V128.27Z",
    fill: "url(#paint100_linear_2723_72924)"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.625 105.334L139.089 110.226L130.624 115.115L122.16 110.223L130.625 105.334Z",
    fill: "url(#paint101_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.096 119.94L130.627 124.83V115.112L139.096 110.223V119.94Z",
    fill: "url(#paint102_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.628 124.83L122.16 119.94V110.223L130.628 115.112V124.83Z",
    fill: "url(#paint103_linear_2723_72924)"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.624 88.0762L142.124 94.7236L130.623 101.366L119.123 94.719L130.624 88.0762Z",
    fill: "url(#paint104_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.133 107.922L130.627 114.566V101.362L142.133 94.7188V107.922Z",
    fill: "url(#paint105_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.629 114.566L119.122 107.922V94.7188L130.629 101.362V114.566Z",
    fill: "url(#paint106_linear_2723_72924)"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.624 74.3711L142.124 81.0185L130.623 87.6613L119.123 81.0139L130.624 74.3711Z",
    fill: "url(#paint107_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.133 94.2173L130.627 100.86V87.6565L142.133 81.0137V94.2173Z",
    fill: "url(#paint108_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.629 100.86L119.122 94.2173V81.0137L130.629 87.6565V100.86Z",
    fill: "url(#paint109_linear_2723_72924)"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.546 81.3164L154.046 87.9638L142.544 94.6074L131.045 87.9592L142.546 81.3164Z",
    fill: "url(#paint110_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.055 101.165L142.549 107.808V94.6046L154.055 87.9609V101.165Z",
    fill: "url(#paint111_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.551 107.808L131.044 101.165V87.9609L142.551 94.6046V107.808Z",
    fill: "url(#paint112_linear_2723_72924)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M190.862 170.442L211.869 158.417L208.729 156.652L244.278 136.342L264.866 147.925L229.329 168.229L226.31 166.532L205.205 178.615L190.862 170.442Z",
    fill: "url(#paint113_linear_2723_72924)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M209.476 152.207C209.476 153.665 209.979 154.697 210.796 155.197C210.821 155.212 213.379 156.692 213.404 156.706C214.254 157.182 213.711 156.103 215.003 155.357C217.603 153.856 219.71 150.22 219.71 147.237C219.71 145.762 221.074 145.75 220.238 145.257C220.215 145.244 217.493 143.737 217.47 143.725C216.621 143.265 215.462 143.35 214.183 144.088C211.583 145.589 209.476 149.224 209.476 152.207Z",
    fill: "url(#paint114_linear_2723_72924)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M212.202 153.755C212.202 156.738 214.31 157.94 216.91 156.439C219.509 154.938 221.617 151.303 221.617 148.319C221.617 145.336 219.509 144.133 216.91 145.635C214.309 147.137 212.202 150.772 212.202 153.755Z",
    fill: "url(#paint115_linear_2723_72924)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M216.683 145.523C217.929 144.803 219.061 144.706 219.903 145.127C219.118 144.908 218.144 145.072 217.09 145.681C214.489 147.181 212.382 150.817 212.382 153.801C212.382 155.354 212.954 156.423 213.869 156.88C212.72 156.559 211.976 155.415 211.976 153.643C211.976 150.659 214.083 147.023 216.683 145.523Z",
    fill: "url(#paint116_radial_2723_72924)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M216.947 147.78C215.269 148.748 213.904 151.103 213.904 153.027C213.904 154.953 215.269 155.731 216.947 154.762C218.625 153.793 219.989 151.439 219.989 149.514C219.989 147.59 218.625 146.812 216.947 147.78Z",
    fill: "url(#paint117_linear_2723_72924)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M215.865 154.068C217.543 153.099 218.907 150.745 218.907 148.82C218.907 148.227 218.777 147.743 218.548 147.385C219.411 147.503 219.989 148.265 219.989 149.515C219.989 151.441 218.625 153.795 216.947 154.763C215.786 155.433 214.777 155.266 214.264 154.464C214.729 154.528 215.277 154.407 215.865 154.068Z",
    fill: "url(#paint118_linear_2723_72924)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M214.988 152.077C214.988 153.085 215.7 153.49 216.578 152.984C217.456 152.477 218.168 151.25 218.168 150.242C218.168 149.234 217.456 148.829 216.578 149.335C215.7 149.842 214.988 151.07 214.988 152.077Z",
    fill: "url(#paint119_radial_2723_72924)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M215.422 152.376C215.422 153.384 216.134 153.789 217.012 153.282C217.889 152.776 218.601 151.548 218.601 150.541C218.601 149.533 217.889 149.127 217.012 149.634C216.133 150.141 215.422 151.368 215.422 152.376Z",
    fill: "url(#paint120_linear_2723_72924)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M225.723 130.42H226.471V128.559H225.723V130.42Z",
    fill: "url(#paint121_linear_2723_72924)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M225.723 132.558H226.471V131.572H225.723V132.558Z",
    fill: "url(#paint122_linear_2723_72924)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M225.892 131.898H226.303V129.945H225.892V131.898Z",
    fill: "url(#paint123_linear_2723_72924)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M224.76 114.475L216.059 142.124L214.906 141.46L223.608 113.811L224.76 114.475Z",
    fill: "url(#paint124_linear_2723_72924)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M224.757 114.475L216.056 142.124L217.199 141.46L225.901 113.814L224.757 114.475Z",
    fill: "url(#paint125_linear_2723_72924)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M225.901 113.814L224.757 114.474L223.608 113.81L224.757 113.146L225.901 113.814Z",
    fill: "url(#paint126_linear_2723_72924)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M237.221 152.399V157.462L215.372 144.751V139.688L237.221 152.399Z",
    fill: "url(#paint127_linear_2723_72924)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M237.214 152.398V157.461L256.006 146.564V141.508L237.214 152.398Z",
    fill: "url(#paint128_linear_2723_72924)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M256.006 141.508L237.214 152.398L215.372 139.687L234.177 128.789L256.006 141.508Z",
    fill: "url(#paint129_linear_2723_72924)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M256.004 132.551V146.619L234.155 133.907V119.84L256.004 132.551Z",
    fill: "url(#paint130_linear_2723_72924)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M255.997 132.552V146.62L263.015 142.53V136.105L259.839 130.684L255.997 132.552Z",
    fill: "url(#paint131_linear_2723_72924)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M259.839 130.684L255.997 132.552L234.155 119.841L238.01 117.965L259.839 130.684Z",
    fill: "url(#paint132_linear_2723_72924)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M237.221 151.164V152.621L215.372 139.91V138.453L237.221 151.164Z",
    fill: "url(#paint133_linear_2723_72924)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M237.214 151.163V152.62L256.006 141.722V140.273L237.214 151.163Z",
    fill: "url(#paint134_linear_2723_72924)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M256.006 140.274L237.214 151.163L215.372 138.452L234.177 127.555L256.006 140.274Z",
    fill: "url(#paint135_linear_2723_72924)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M236.339 107.099V132.843L235.188 132.179V106.436L236.339 107.099Z",
    fill: "url(#paint136_linear_2723_72924)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M236.336 107.099V132.843L237.48 132.18V106.439L236.336 107.099Z",
    fill: "url(#paint137_linear_2723_72924)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M237.48 106.439L236.336 107.098L235.188 106.435L236.336 105.771L237.48 106.439Z",
    fill: "url(#paint138_linear_2723_72924)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M231.956 128.462L232.85 127.057L233.161 127.039L233.581 126.308L232.577 125.742L232.12 126.491L232.284 126.819L231.5 128.134L231.956 128.462Z",
    fill: "url(#paint139_linear_2723_72924)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M242.797 139.646L239.766 146.474L224.896 137.894L227.927 131.066L242.797 139.646Z",
    fill: "url(#paint140_linear_2723_72924)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M242.79 139.645L239.76 146.473L252.258 139.262V134.207L242.79 139.645Z",
    fill: "url(#paint141_linear_2723_72924)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M252.258 134.207L242.79 139.645L227.927 131.065L237.409 125.619L252.258 134.207Z",
    fill: "url(#paint142_linear_2723_72924)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M232.756 128.815L230.441 127.459L225.677 132.972L230.697 135.856L232.756 128.815Z",
    fill: "url(#paint143_linear_2723_72924)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M232.09 128.416L230.441 127.459L225.677 132.972L229.462 135.116L232.09 128.416Z",
    fill: "url(#paint144_linear_2723_72924)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M230.19 124.342C229.966 124.737 231.095 125.802 232.712 126.721C234.329 127.64 235.822 128.064 236.046 127.668C236.271 127.273 235.142 126.207 233.525 125.288C231.908 124.37 230.415 123.946 230.19 124.342Z",
    fill: "url(#paint145_linear_2723_72924)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M223.64 153.248L223.638 158.365L212.802 152.113L212.803 146.996L223.64 153.248Z",
    fill: "url(#paint146_linear_2723_72924)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M223.633 153.246L223.632 158.363L230.191 154.536V149.48L223.633 153.246Z",
    fill: "url(#paint147_linear_2723_72924)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M230.191 149.482L223.633 153.248L212.804 146.996L219.375 143.223L230.191 149.482Z",
    fill: "url(#paint148_linear_2723_72924)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M224.104 159.854C224.104 161.311 224.607 162.343 225.424 162.843C225.448 162.858 228.007 164.338 228.032 164.353C228.882 164.829 228.339 163.75 229.631 163.003C232.231 161.503 234.338 157.867 234.338 154.883C234.338 153.408 235.702 153.396 234.866 152.904C234.843 152.89 232.121 151.383 232.097 151.371C231.249 150.911 230.09 150.997 228.811 151.734C226.211 153.235 224.104 156.87 224.104 159.854Z",
    fill: "url(#paint149_linear_2723_72924)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M226.83 161.402C226.83 164.385 228.938 165.586 231.538 164.085C234.137 162.585 236.245 158.949 236.245 155.965C236.245 152.982 234.137 151.78 231.538 153.281C228.937 154.783 226.83 158.418 226.83 161.402Z",
    fill: "url(#paint150_linear_2723_72924)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M231.311 153.169C232.557 152.449 233.689 152.352 234.531 152.774C233.746 152.554 232.772 152.718 231.718 153.327C229.117 154.828 227.01 158.464 227.01 161.447C227.01 163 227.582 164.069 228.497 164.527C227.347 164.205 226.604 163.062 226.604 161.289C226.604 158.306 228.711 154.671 231.311 153.169Z",
    fill: "url(#paint151_radial_2723_72924)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M231.575 155.427C229.897 156.395 228.532 158.749 228.532 160.674C228.532 162.6 229.897 163.378 231.575 162.409C233.253 161.44 234.617 159.086 234.617 157.161C234.617 155.236 233.253 154.458 231.575 155.427Z",
    fill: "url(#paint152_linear_2723_72924)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M230.493 161.714C232.17 160.746 233.535 158.391 233.535 156.467C233.535 155.873 233.405 155.389 233.176 155.031C234.039 155.149 234.617 155.912 234.617 157.162C234.617 159.087 233.252 161.442 231.575 162.41C230.414 163.08 229.405 162.913 228.892 162.11C229.357 162.175 229.905 162.054 230.493 161.714Z",
    fill: "url(#paint153_linear_2723_72924)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M229.616 159.724C229.616 160.731 230.328 161.137 231.206 160.63C232.084 160.123 232.796 158.896 232.796 157.888C232.796 156.881 232.084 156.475 231.206 156.982C230.327 157.489 229.616 158.717 229.616 159.724Z",
    fill: "url(#paint154_radial_2723_72924)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M230.05 160.024C230.05 161.032 230.762 161.438 231.639 160.931C232.517 160.424 233.229 159.197 233.229 158.189C233.229 157.182 232.517 156.776 231.639 157.283C230.761 157.79 230.05 159.017 230.05 160.024Z",
    fill: "url(#paint155_linear_2723_72924)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M238.995 150.958L233.801 149.714L229.018 152.415L226.463 150.918L231.464 148.107L236.466 149.495L238.995 150.958Z",
    fill: "url(#paint156_linear_2723_72924)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M238.995 150.958L237.951 151.527L233.866 150.682L229.07 153.303L229.019 152.414L233.801 149.713L238.995 150.958Z",
    fill: "url(#paint157_linear_2723_72924)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M226.463 150.918V151.838L229.07 153.303L229.018 152.415L226.463 150.918Z",
    fill: "url(#paint158_linear_2723_72924)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M215.92 141.471L230.979 150.178L234.758 137.912L220.082 129.424L215.92 141.471Z",
    fill: "url(#paint159_linear_2723_72924)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M244.768 133.392L246.455 125.389C246.598 124.707 246.278 124.012 245.667 123.677L240.705 120.966C240.355 120.775 239.919 120.964 239.819 121.35L237.987 128.392L244.768 133.392Z",
    fill: "url(#paint160_linear_2723_72924)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M239.685 135.297V136.303L232.89 132.308V131.303L239.685 135.297Z",
    fill: "url(#paint161_linear_2723_72924)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M239.681 135.297V136.303L244.767 133.393V132.393L239.681 135.297Z",
    fill: "url(#paint162_linear_2723_72924)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M244.767 132.393L239.681 135.297L232.89 131.303L237.986 128.393L244.767 132.393Z",
    fill: "url(#paint163_linear_2723_72924)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M250.216 147.76C250.216 149.217 250.719 150.249 251.536 150.749C251.561 150.765 254.119 152.245 254.144 152.259C254.995 152.735 254.451 151.656 255.743 150.91C258.343 149.409 260.451 145.774 260.451 142.79C260.451 141.315 261.815 141.303 260.979 140.81C260.955 140.796 258.233 139.29 258.21 139.277C257.362 138.818 256.202 138.903 254.923 139.641C252.324 141.141 250.216 144.777 250.216 147.76Z",
    fill: "url(#paint164_linear_2723_72924)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M252.942 149.307C252.942 152.291 255.05 153.493 257.65 151.991C260.249 150.491 262.357 146.855 262.357 143.871C262.357 140.888 260.249 139.687 257.65 141.187C255.05 142.689 252.942 146.324 252.942 149.307Z",
    fill: "url(#paint165_linear_2723_72924)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M257.424 141.075C258.67 140.356 259.803 140.258 260.645 140.68C259.86 140.461 258.885 140.625 257.831 141.234C255.23 142.735 253.123 146.37 253.123 149.354C253.123 150.907 253.695 151.976 254.61 152.434C253.461 152.113 252.717 150.969 252.717 149.196C252.717 146.211 254.825 142.576 257.424 141.075Z",
    fill: "url(#paint166_radial_2723_72924)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M257.688 143.334C256.01 144.303 254.646 146.657 254.646 148.582C254.646 150.508 256.01 151.286 257.688 150.317C259.366 149.348 260.731 146.994 260.731 145.069C260.731 143.144 259.366 142.366 257.688 143.334Z",
    fill: "url(#paint167_linear_2723_72924)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M256.605 149.621C258.283 148.652 259.648 146.298 259.648 144.373C259.648 143.779 259.517 143.295 259.288 142.938C260.151 143.055 260.73 143.818 260.73 145.068C260.73 146.994 259.365 149.348 257.687 150.316C256.527 150.986 255.517 150.819 255.004 150.016C255.47 150.08 256.018 149.96 256.605 149.621Z",
    fill: "url(#paint168_linear_2723_72924)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M255.796 147.729C255.796 148.737 256.508 149.143 257.386 148.636C258.263 148.129 258.975 146.902 258.975 145.894C258.975 144.887 258.263 144.481 257.386 144.988C256.508 145.495 255.796 146.722 255.796 147.729Z",
    fill: "url(#paint169_radial_2723_72924)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M256.162 147.929C256.162 148.936 256.874 149.342 257.752 148.835C258.629 148.328 259.341 147.101 259.341 146.094C259.341 145.086 258.63 144.68 257.752 145.187C256.874 145.694 256.162 146.921 256.162 147.929Z",
    fill: "url(#paint170_linear_2723_72924)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M253.203 114.583V140.327L252.051 139.664V113.92L253.203 114.583Z",
    fill: "url(#paint171_linear_2723_72924)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M253.199 114.582V140.326L254.342 139.663V113.922L253.199 114.582Z",
    fill: "url(#paint172_linear_2723_72924)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M254.343 113.922L253.2 114.583L252.051 113.919L253.2 113.256L254.343 113.922Z",
    fill: "url(#paint173_linear_2723_72924)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M239.812 123.132L231.11 150.782L229.958 150.118L238.659 122.469L239.812 123.132Z",
    fill: "url(#paint174_linear_2723_72924)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M239.809 123.133L231.106 150.783L232.25 150.119L240.951 122.473L239.809 123.133Z",
    fill: "url(#paint175_linear_2723_72924)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M240.952 122.472L239.809 123.132L238.659 122.469L239.809 121.805L240.952 122.472Z",
    fill: "url(#paint176_linear_2723_72924)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M242.142 136.872H242.471V134.408H242.142V136.872Z",
    fill: "url(#paint177_linear_2723_72924)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M239.813 121.889V123.113L223.587 113.87V112.646L239.813 121.889Z",
    fill: "url(#paint178_linear_2723_72924)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M239.808 121.89V123.114L254.343 114.776V113.559L239.808 121.89Z",
    fill: "url(#paint179_linear_2723_72924)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M254.343 113.558L239.808 121.889L223.587 112.647L238.133 104.309L254.343 113.558Z",
    fill: "url(#paint180_linear_2723_72924)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M241.734 134.211C241.734 134.527 241.99 134.783 242.306 134.783C242.621 134.783 242.876 134.527 242.876 134.211C242.876 133.896 242.621 133.641 242.306 133.641C241.99 133.641 241.734 133.896 241.734 134.211Z",
    fill: "url(#paint181_linear_2723_72924)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M241.509 137.564C241.509 138.105 241.865 138.167 242.305 138.167C242.745 138.167 243.101 138.104 243.101 137.564C243.101 137.023 242.745 136.209 242.305 136.209C241.866 136.209 241.509 137.023 241.509 137.564Z",
    fill: "url(#paint182_linear_2723_72924)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M239.851 123.113L239.637 121.889L223.63 112.646L239.815 121.622L254.386 113.558L240.082 121.978L239.851 123.113Z",
    fill: "url(#paint183_radial_2723_72924)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M233.755 149.768L229.07 152.448L226.417 150.972L229.048 152.148L233.755 149.768Z",
    fill: "url(#paint184_radial_2723_72924)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M227.502 113.56L226.407 116.964L219.247 112.857V108.711L227.502 113.56Z",
    fill: "url(#paint185_linear_2723_72924)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M219.247 108.711V112.857L216.495 114.39L216.304 110.247L219.247 108.711Z",
    fill: "url(#paint186_linear_2723_72924)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M214.986 112.173V161.131L212.612 159.764V110.807L214.986 112.173Z",
    fill: "url(#paint187_linear_2723_72924)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M214.979 112.174V161.132L217.334 159.765V110.814L214.979 112.174Z",
    fill: "url(#paint188_linear_2723_72924)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M217.334 110.813L214.979 112.173L212.612 110.806L214.979 109.439L217.334 110.813Z",
    fill: "url(#paint189_linear_2723_72924)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M221.309 121.912L221.308 124.417L214.956 120.749L214.957 118.244L221.309 121.912Z",
    fill: "url(#paint190_linear_2723_72924)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M221.305 121.912L221.305 124.418L223.187 123.323V120.848L221.305 121.912Z",
    fill: "url(#paint191_linear_2723_72924)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M223.187 120.848L221.306 121.913L214.957 118.245L216.845 117.176L223.187 120.848Z",
    fill: "url(#paint192_linear_2723_72924)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M221.309 162.235L221.308 164.74L214.956 161.072L214.957 158.566L221.309 162.235Z",
    fill: "url(#paint193_linear_2723_72924)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M221.305 162.235L221.305 164.74L223.187 163.645V161.17L221.305 162.235Z",
    fill: "url(#paint194_linear_2723_72924)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M223.187 161.171L221.306 162.235L214.957 158.566L216.845 157.498L223.187 161.171Z",
    fill: "url(#paint195_linear_2723_72924)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M222.269 116.386V165.344L219.896 163.977V115.02L222.269 116.386Z",
    fill: "url(#paint196_linear_2723_72924)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M222.263 116.387V165.345L224.618 163.978V115.027L222.263 116.387Z",
    fill: "url(#paint197_linear_2723_72924)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M224.617 115.026L222.263 116.386L219.896 115.019L222.263 113.652L224.617 115.026Z",
    fill: "url(#paint198_linear_2723_72924)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M223.478 116.983L229.721 113.369L219.726 107.592L215.619 109.919L216.304 110.248L219.248 108.711L227.503 113.561L222.957 116.627L223.478 116.983Z",
    fill: "url(#paint199_linear_2723_72924)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M223.478 116.984V121.017L229.725 117.431V113.371L223.478 116.984Z",
    fill: "url(#paint200_linear_2723_72924)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M222.957 116.627V120.77L223.478 121.016V116.983L222.957 116.627Z",
    fill: "url(#paint201_linear_2723_72924)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M219.895 115.086L222.322 116.132L224.616 115.093L222.455 116.62L222.277 149.745L222.055 116.486L219.895 115.086Z",
    fill: "url(#paint202_radial_2723_72924)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M253.595 131.233L256.022 132.278L259.696 130.713L256.155 132.767L255.977 139.072L255.755 132.634L253.595 131.233Z",
    fill: "url(#paint203_radial_2723_72924)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M239.76 146.472L242.546 139.627L237.04 136.296L242.857 139.227L251.737 134.564L242.99 139.716L239.76 146.472Z",
    fill: "url(#paint204_radial_2723_72924)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M244.767 132.39L244.178 132.677L246.276 124.885L244.767 132.39Z",
    fill: "url(#paint205_radial_2723_72924)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M209.149 154.061V155.247L210.184 154.651V153.465L209.149 154.061Z",
    fill: "url(#paint206_linear_2723_72924)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M209.152 154.06V155.246L198.85 149.283V148.1L209.152 154.06Z",
    fill: "url(#paint207_linear_2723_72924)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M198.85 148.101L209.152 154.061L210.184 153.465L199.876 147.502L198.85 148.101Z",
    fill: "url(#paint208_linear_2723_72924)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M212.911 151.945V153.132L213.946 152.537V151.35L212.911 151.945Z",
    fill: "url(#paint209_linear_2723_72924)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M212.915 151.945V153.132L202.611 147.168V145.984L212.915 151.945Z",
    fill: "url(#paint210_linear_2723_72924)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M202.611 145.985L212.915 151.946L213.946 151.35L203.638 145.387L202.611 145.985Z",
    fill: "url(#paint211_linear_2723_72924)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M216.632 149.748V150.935L217.667 150.339V149.152L216.632 149.748Z",
    fill: "url(#paint212_linear_2723_72924)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M216.635 149.748V150.935L206.332 144.971V143.787L216.635 149.748Z",
    fill: "url(#paint213_linear_2723_72924)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M206.332 143.788L216.635 149.749L217.667 149.153L207.359 143.189L206.332 143.788Z",
    fill: "url(#paint214_linear_2723_72924)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M195.056 147.615V151.494L194.021 150.898V147.02L195.056 147.615Z",
    fill: "url(#paint215_linear_2723_72924)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M195.054 147.614V151.493L196.08 150.897V147.021L195.054 147.614Z",
    fill: "url(#paint216_linear_2723_72924)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M196.08 147.023L195.053 147.615L194.021 147.02L195.053 146.424L196.08 147.023Z",
    fill: "url(#paint217_linear_2723_72924)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M205.345 156.258V157.444L206.379 156.848V155.662L205.345 156.258Z",
    fill: "url(#paint218_linear_2723_72924)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M205.347 156.257V157.444L195.045 151.48V150.297L205.347 156.257Z",
    fill: "url(#paint219_linear_2723_72924)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M195.045 150.298L205.347 156.258L206.379 155.663L196.072 149.699L195.045 150.298Z",
    fill: "url(#paint220_linear_2723_72924)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M212.196 131.404V141.201C212.196 142.372 211.514 143.436 210.449 143.925L195.069 150.988C194.589 151.208 194.033 151.189 193.57 150.936C193.192 150.73 193.19 150.188 193.565 149.978L207.519 142.192C208.468 141.662 209.055 140.661 209.055 139.574V129.615L212.196 131.404Z",
    fill: "url(#paint221_linear_2723_72924)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M194.267 150.805L209.647 143.743C210.711 143.254 211.394 142.19 211.394 141.019V131.222L209.057 129.89V129.615L212.197 131.404V141.201C212.197 142.372 211.514 143.436 210.45 143.925L195.07 150.988C194.603 151.202 194.065 151.187 193.609 150.954C193.834 150.949 194.057 150.901 194.267 150.805Z",
    fill: "url(#paint222_linear_2723_72924)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M221.309 142.753L221.308 145.258L214.956 141.589L214.957 139.084L221.309 142.753Z",
    fill: "url(#paint223_linear_2723_72924)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M221.305 142.753L221.305 145.258L223.187 144.163V141.688L221.305 142.753Z",
    fill: "url(#paint224_linear_2723_72924)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M223.187 141.687L221.306 142.753L214.957 139.084L216.845 138.016L223.187 141.687Z",
    fill: "url(#paint225_linear_2723_72924)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M223.477 130.637V146.189L221.907 147.102V131.586L223.477 130.637Z",
    fill: "url(#paint226_linear_2723_72924)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M223.477 130.637L210.98 123.426L209.41 124.338L221.907 131.586L223.477 130.637Z",
    fill: "url(#paint227_linear_2723_72924)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M221.907 147.102V131.586L209.41 124.338V129.814L210.277 130.305V125.879L220.967 131.97V146.508L221.907 147.102Z",
    fill: "url(#paint228_linear_2723_72924)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M210.277 125.879V130.305L210.91 130.671V126.242L210.277 125.879Z",
    fill: "url(#paint229_linear_2723_72924)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M220.961 136.465V146.262C220.961 147.433 220.278 148.496 219.215 148.986L203.835 156.048C203.355 156.268 202.799 156.249 202.335 155.996C201.958 155.79 201.956 155.249 202.331 155.039L216.285 147.253C217.234 146.723 217.821 145.721 217.821 144.635V134.676L220.961 136.465Z",
    fill: "url(#paint230_linear_2723_72924)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M203.031 155.864L218.41 148.801C219.475 148.313 220.157 147.249 220.157 146.077V136.28L217.82 134.949V134.674L220.96 136.463V146.26C220.96 147.431 220.277 148.494 219.214 148.984L203.834 156.046C203.367 156.26 202.829 156.246 202.374 156.013C202.598 156.008 202.822 155.96 203.031 155.864Z",
    fill: "url(#paint231_linear_2723_72924)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M210.153 151.998V155.876L209.119 155.281V151.402L210.153 151.998Z",
    fill: "url(#paint232_linear_2723_72924)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M210.151 151.998V155.877L211.178 155.281V151.406L210.151 151.998Z",
    fill: "url(#paint233_linear_2723_72924)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M211.178 151.406L210.151 151.998L209.119 151.402L210.151 150.807L211.178 151.406Z",
    fill: "url(#paint234_linear_2723_72924)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M213.922 149.824V153.702L212.887 153.106V149.229L213.922 149.824Z",
    fill: "url(#paint235_linear_2723_72924)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M213.919 149.825V153.703L214.946 153.107V149.232L213.919 149.825Z",
    fill: "url(#paint236_linear_2723_72924)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M214.945 149.232L213.919 149.825L212.887 149.229L213.919 148.633L214.945 149.232Z",
    fill: "url(#paint237_linear_2723_72924)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M217.69 147.65V151.528L216.656 150.932V147.055L217.69 147.65Z",
    fill: "url(#paint238_linear_2723_72924)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M217.688 147.649V151.527L218.715 150.931V147.057L217.688 147.649Z",
    fill: "url(#paint239_linear_2723_72924)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M218.715 147.058L217.688 147.65L216.656 147.055L217.688 146.459L218.715 147.058Z",
    fill: "url(#paint240_linear_2723_72924)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M207.405 153.584V154.77L206.37 154.174V152.988L207.405 153.584Z",
    fill: "url(#paint241_linear_2723_72924)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M207.402 153.584V154.77L217.706 148.806V147.623L207.402 153.584Z",
    fill: "url(#paint242_linear_2723_72924)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M217.705 147.624L207.402 153.585L206.37 152.989L216.679 147.025L217.705 147.624Z",
    fill: "url(#paint243_linear_2723_72924)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M205.345 153.625V154.812L206.379 154.215V153.029L205.345 153.625Z",
    fill: "url(#paint244_linear_2723_72924)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M205.347 153.625V154.811L195.045 148.848V147.664L205.347 153.625Z",
    fill: "url(#paint245_linear_2723_72924)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M195.045 147.665L205.347 153.626L206.379 153.03L196.072 147.066L195.045 147.665Z",
    fill: "url(#paint246_linear_2723_72924)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M206.385 154.172V158.05L205.35 157.455V153.576L206.385 154.172Z",
    fill: "url(#paint247_linear_2723_72924)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M206.382 154.171V158.049L207.408 157.454V153.578L206.382 154.171Z",
    fill: "url(#paint248_linear_2723_72924)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M207.408 153.579L206.382 154.172L205.35 153.576L206.382 152.98L207.408 153.579Z",
    fill: "url(#paint249_linear_2723_72924)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M218.73 147.061L206.412 154.172L194.028 147.023L206.412 139.873L218.73 147.061Z",
    fill: "url(#paint250_linear_2723_72924)"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.511 127.08L218.011 133.728L206.511 140.37L195.011 133.723L206.511 127.08Z",
    fill: "url(#paint251_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.021 146.926L206.515 153.569V140.365L218.021 133.723V146.926Z",
    fill: "url(#paint252_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.517 153.569L195.01 146.926V133.723L206.517 140.365V153.569Z",
    fill: "url(#paint253_linear_2723_72924)"
  }))), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M206.385 140.418L206.375 140.423L194.875 133.775L183.374 140.418L183.922 140.735L183.374 140.418V153.622L194.878 160.264V160.265L194.879 160.264L194.88 160.265V160.264L206.385 153.622V140.418Z",
    fill: "url(#paint254_linear_2723_72924)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M206.358 140.481L206.351 140.484L197.868 135.58L189.385 140.48L189.789 140.714L189.384 140.481V150.22L197.87 155.12V155.12L197.871 155.12L197.872 155.12V155.12L206.358 150.22V140.481Z",
    fill: "url(#paint255_linear_2723_72924)"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.469 130.656L214.933 135.548L206.468 140.437L198.005 135.545L206.469 130.656Z",
    fill: "url(#paint256_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.94 145.262L206.471 150.152V140.434L214.94 135.545V145.262Z",
    fill: "url(#paint257_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.473 150.152L198.004 145.262V135.545L206.473 140.434V150.152Z",
    fill: "url(#paint258_linear_2723_72924)"
  }))), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M1.50488 149.814L36.5155 129.811L40.3004 131.94L58.2244 122.523L70.5063 129.434L53.8201 139.546L56.792 141.219L21.7928 161.216L1.50488 149.814Z",
    fill: "url(#paint259_linear_2723_72924)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6072 101.931L33.4263 123.223L32.2918 122.569L25.4727 101.277L26.6072 101.931Z",
    fill: "url(#paint260_linear_2723_72924)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6045 101.932L33.4236 123.223L34.5498 122.57L27.7306 101.281L26.6045 101.932Z",
    fill: "url(#paint261_linear_2723_72924)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7303 101.282L26.6041 101.932L25.4727 101.278L26.6041 100.625L27.7303 101.282Z",
    fill: "url(#paint262_linear_2723_72924)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7368 112.319V113.525L37.79 105.541V104.336L51.7368 112.319Z",
    fill: "url(#paint263_linear_2723_72924)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7314 112.319V113.525L53.7953 112.363V111.164L51.7314 112.319Z",
    fill: "url(#paint264_linear_2723_72924)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7953 111.164L51.7315 112.319L37.79 104.336L39.8653 103.174L53.7953 111.164Z",
    fill: "url(#paint265_linear_2723_72924)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4346 108.859V110.046L61.4695 109.451V108.264L60.4346 108.859Z",
    fill: "url(#paint266_linear_2723_72924)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4379 108.859V110.046L50.1348 104.082V102.898L60.4379 108.859Z",
    fill: "url(#paint267_linear_2723_72924)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1348 102.9L60.4379 108.86L61.4698 108.264L51.1613 102.301L50.1348 102.9Z",
    fill: "url(#paint268_linear_2723_72924)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1982 106.745V107.931L65.2332 107.335V106.148L64.1982 106.745Z",
    fill: "url(#paint269_linear_2723_72924)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2008 106.746V107.932L53.8984 101.968V100.785L64.2008 106.746Z",
    fill: "url(#paint270_linear_2723_72924)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8984 100.785L64.2008 106.746L65.2335 106.149L54.925 100.186L53.8984 100.785Z",
    fill: "url(#paint271_linear_2723_72924)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M67.918 104.546V105.732L68.9522 105.136V103.949L67.918 104.546Z",
    fill: "url(#paint272_linear_2723_72924)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9204 104.546V105.733L57.6172 99.7691V98.5859L67.9204 104.546Z",
    fill: "url(#paint273_linear_2723_72924)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6172 98.5859L67.9204 104.546L68.9523 103.95L58.6438 97.9863L57.6172 98.5859Z",
    fill: "url(#paint274_linear_2723_72924)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4392 106.795V110.673L60.4043 110.077V106.199L61.4392 106.795Z",
    fill: "url(#paint275_linear_2723_72924)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4365 106.796V110.673L62.4624 110.078V106.203L61.4365 106.796Z",
    fill: "url(#paint276_linear_2723_72924)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4628 106.203L61.437 106.796L60.4043 106.2L61.437 105.604L62.4628 106.203Z",
    fill: "url(#paint277_linear_2723_72924)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2078 104.623V108.501L64.1729 107.905V104.027L65.2078 104.623Z",
    fill: "url(#paint278_linear_2723_72924)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2051 104.622V108.5L66.2317 107.904V104.029L65.2051 104.622Z",
    fill: "url(#paint279_linear_2723_72924)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2313 104.03L65.2048 104.623L64.1729 104.027L65.2048 103.432L66.2313 104.03Z",
    fill: "url(#paint280_linear_2723_72924)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9764 102.449V106.327L67.9414 105.731V101.854L68.9764 102.449Z",
    fill: "url(#paint281_linear_2723_72924)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9736 102.448V106.326L70.0002 105.73V101.855L68.9736 102.448Z",
    fill: "url(#paint282_linear_2723_72924)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9999 101.857L68.9733 102.449L67.9414 101.854L68.9733 101.258L69.9999 101.857Z",
    fill: "url(#paint283_linear_2723_72924)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3426 102.413V106.291L45.3076 105.695V101.816L46.3426 102.413Z",
    fill: "url(#paint284_linear_2723_72924)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3398 102.413V106.291L47.3664 105.695V101.82L46.3398 102.413Z",
    fill: "url(#paint285_linear_2723_72924)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3661 101.82L46.3395 102.413L45.3076 101.816L46.3395 101.221L47.3661 101.82Z",
    fill: "url(#paint286_linear_2723_72924)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6299 111.055V112.241L57.6648 111.645V110.459L56.6299 111.055Z",
    fill: "url(#paint287_linear_2723_72924)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6333 111.054V112.24L46.3301 106.278V105.094L56.6333 111.054Z",
    fill: "url(#paint288_linear_2723_72924)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3301 105.095L56.6333 111.055L57.6652 110.46L47.3567 104.496L46.3301 105.095Z",
    fill: "url(#paint289_linear_2723_72924)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6088 112.42L48.6787 110.758C48.6787 110.758 64.2463 102.886 65.5586 102.318C66.8702 101.75 69.8002 102.012 67.2638 103.455C64.7273 104.899 51.6088 112.42 51.6088 112.42Z",
    fill: "url(#paint290_linear_2723_72924)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6088 111.895C51.6088 111.895 64.7273 104.374 67.2638 102.931C67.7167 102.673 67.9925 102.454 68.1369 102.27C68.4165 102.491 68.2767 102.879 67.2638 103.455C64.7273 104.898 51.6088 112.419 51.6088 112.419L48.6787 110.757C48.6787 110.757 48.855 110.668 49.1681 110.51L51.6088 111.895Z",
    fill: "url(#paint291_linear_2723_72924)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9496 107.521L40.0195 105.86C40.0195 105.86 55.5871 97.988 56.8994 97.4197C58.2117 96.8513 61.1411 97.1134 58.6046 98.5564C56.0681 100 42.9496 107.521 42.9496 107.521Z",
    fill: "url(#paint292_linear_2723_72924)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9496 106.996C42.9496 106.996 56.0681 99.4752 58.6046 98.0322C59.0575 97.7746 59.3333 97.5557 59.4777 97.3711C59.7573 97.593 59.6175 97.9805 58.6046 98.5565C56.0681 99.9995 42.9496 107.521 42.9496 107.521L40.0195 105.859C40.0195 105.859 40.1951 105.77 40.5089 105.612L42.9496 106.996Z",
    fill: "url(#paint293_linear_2723_72924)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6912 108.381V109.567L57.6562 108.971V107.785L58.6912 108.381Z",
    fill: "url(#paint294_linear_2723_72924)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6885 108.38V109.567L68.9917 103.604V102.42L58.6885 108.38Z",
    fill: "url(#paint295_linear_2723_72924)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9914 102.421L58.6882 108.382L57.6562 107.786L67.9647 101.822L68.9914 102.421Z",
    fill: "url(#paint296_linear_2723_72924)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6299 108.422V109.609L57.6648 109.013V107.826L56.6299 108.422Z",
    fill: "url(#paint297_linear_2723_72924)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6333 108.421V109.608L46.3301 103.645V102.461L56.6333 108.421Z",
    fill: "url(#paint298_linear_2723_72924)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3301 102.462L56.6333 108.423L57.6652 107.827L47.3567 101.863L46.3301 102.462Z",
    fill: "url(#paint299_linear_2723_72924)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6707 108.97V112.847L56.6357 112.251V108.373L57.6707 108.97Z",
    fill: "url(#paint300_linear_2723_72924)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M57.668 108.97V112.847L58.6946 112.252V108.377L57.668 108.97Z",
    fill: "url(#paint301_linear_2723_72924)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6943 108.377L57.6677 108.97L56.6357 108.373L57.6677 107.777L58.6943 108.377Z",
    fill: "url(#paint302_linear_2723_72924)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0163 101.858L57.698 108.969L45.3135 101.82L57.698 94.6699L70.0163 101.858Z",
    fill: "url(#paint303_linear_2723_72924)"
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7966 81.8789L69.2959 88.5263L57.7951 95.1692L46.2959 88.5218L57.7966 81.8789Z",
    fill: "url(#paint304_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5681 82.0673L69.0681 75.4199L57.5674 82.0628L69.0666 88.7102L69.0711 88.7079V101.909L80.5772 95.2664V82.0628L80.5681 82.0673Z",
    fill: "url(#paint305_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1291 83.5528L69.5585 78.5977L60.9863 83.549L69.557 88.5034L69.56 88.5019V98.3415L78.1367 93.3902V83.549L78.1291 83.5528Z",
    fill: "url(#paint306_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3056 101.725L57.7988 108.368V95.1643L69.3056 88.5215V101.725Z",
    fill: "url(#paint307_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.801 108.368L46.2949 101.725V88.5215L57.801 95.1643V108.368Z",
    fill: "url(#paint308_linear_2723_72924)"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.8178 85.3242L66.2813 90.2163L57.817 95.1054L49.3535 90.2133L57.8178 85.3242Z",
    fill: "url(#paint309_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2884 99.9302L57.8203 104.82V95.1019L66.2884 90.2129V99.9302Z",
    fill: "url(#paint310_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8214 104.82L49.3525 99.9302V90.2129L57.8214 95.1019V104.82Z",
    fill: "url(#paint311_linear_2723_72924)"
  }))), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1774 94.5957V109.913L50.6318 110.811V95.5303L52.1774 94.5957Z",
    fill: "url(#paint312_linear_2723_72924)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1773 94.5948L39.8696 87.4922L38.3232 88.3911L50.6317 95.5294L52.1773 94.5948Z",
    fill: "url(#paint313_linear_2723_72924)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6317 110.812V95.5309L38.3232 88.3926V93.7854L39.1773 94.2695V89.9108L49.7054 95.9093V110.228L50.6317 110.812Z",
    fill: "url(#paint314_linear_2723_72924)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2885 83.8965V135.331L37.9512 133.985V82.5508L40.2885 83.8965Z",
    fill: "url(#paint315_linear_2723_72924)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2822 83.8956V135.33L42.6014 133.984V82.5566L40.2822 83.8956Z",
    fill: "url(#paint316_linear_2723_72924)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6016 82.5577L40.2825 83.8966L37.9512 82.5508L40.2825 81.2051L42.6016 82.5577Z",
    fill: "url(#paint317_linear_2723_72924)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2412 126.082H18.9783V125.111H18.2412V126.082Z",
    fill: "url(#paint318_linear_2723_72924)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M26.723 146.762V151.749L8.67285 141.241V136.254L26.723 146.762Z",
    fill: "url(#paint319_linear_2723_72924)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7158 146.763V151.749L45.2234 141.017V136.037L26.7158 146.763Z",
    fill: "url(#paint320_linear_2723_72924)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2237 136.037L26.7161 146.762L8.67285 136.254L27.1933 125.521L45.2237 136.037Z",
    fill: "url(#paint321_linear_2723_72924)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M26.723 145.545V146.979L8.67285 136.471V135.037L26.723 145.545Z",
    fill: "url(#paint322_linear_2723_72924)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7158 145.546V146.98L45.2234 136.247V134.82L26.7158 145.546Z",
    fill: "url(#paint323_linear_2723_72924)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2237 134.82L26.7161 145.546L8.67285 135.038L27.1933 124.305L45.2237 134.82Z",
    fill: "url(#paint324_linear_2723_72924)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M13.436 109.818V135.172L12.3008 134.518V109.164L13.436 109.818Z",
    fill: "url(#paint325_linear_2723_72924)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4326 109.818V135.172L14.558 134.519V109.168L13.4326 109.818Z",
    fill: "url(#paint326_linear_2723_72924)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5584 109.168L13.433 109.819L12.3008 109.165L13.433 108.512L14.5584 109.168Z",
    fill: "url(#paint327_linear_2723_72924)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2249 138.239L26.2135 143.328L11.5684 134.878L11.5797 129.789L26.2249 138.239Z",
    fill: "url(#paint328_linear_2723_72924)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2175 138.241L26.2061 143.33L38.5153 136.229L35.5419 132.885L26.2175 138.241Z",
    fill: "url(#paint329_linear_2723_72924)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5428 132.883L26.2184 138.24L11.5801 129.79L20.9182 124.426L35.5428 132.883Z",
    fill: "url(#paint330_linear_2723_72924)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.2669 135.386L14.583 128.064L20.9173 124.426L33.5898 131.754L27.2669 135.386Z",
    fill: "#939598"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4217 128.087L43.4886 134.855L28.8442 126.405L26.7773 119.637L41.4217 128.087Z",
    fill: "url(#paint331_linear_2723_72924)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M41.415 128.085L43.4811 134.854L48.5731 131.942L44.3011 126.512L41.415 128.085Z",
    fill: "url(#paint332_linear_2723_72924)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3016 126.513L41.4156 128.087L26.7773 119.637L29.6763 118.055L44.3016 126.513Z",
    fill: "url(#paint333_linear_2723_72924)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8768 125.125L34.4072 122.938L30.9528 120.008L29.9034 119.527L29.5098 123.332L32.8768 125.125Z",
    fill: "url(#paint334_linear_2723_72924)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8768 125.125L30.9528 120.008L29.9034 119.527L29.5098 123.332L32.8768 125.125Z",
    fill: "url(#paint335_linear_2723_72924)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7112 118.085C27.3343 118.748 28.3198 120.019 29.9125 120.924C31.5052 121.828 33.1017 122.024 33.4786 121.361C33.8555 120.697 32.87 119.426 31.2773 118.522C29.6846 117.617 28.0881 117.421 27.7112 118.085Z",
    fill: "url(#paint336_linear_2723_72924)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M24.483 131.561V132.611L17.3857 128.44V127.389L24.483 131.561Z",
    fill: "url(#paint337_linear_2723_72924)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4785 131.562V132.612L29.7923 129.572V128.527L24.4785 131.562Z",
    fill: "url(#paint338_linear_2723_72924)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7922 128.529L24.4784 131.563L17.3857 127.39L22.7087 124.352L29.7922 128.529Z",
    fill: "url(#paint339_linear_2723_72924)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4788 131.561L22.6035 126.593C22.3937 125.782 22.0586 124.925 21.4203 124.576L16.5982 121.973C16.2327 121.773 15.7767 121.971 15.6719 122.374L17.3869 127.39L24.4788 131.561Z",
    fill: "url(#paint340_linear_2723_72924)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3386 118.173V143.528L27.2041 142.874V117.52L28.3386 118.173Z",
    fill: "url(#paint341_linear_2723_72924)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3359 118.175V143.53L29.4621 142.876V117.525L28.3359 118.175Z",
    fill: "url(#paint342_linear_2723_72924)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4617 117.524L28.3355 118.174L27.2041 117.521L28.3355 116.867L29.4617 117.524Z",
    fill: "url(#paint343_linear_2723_72924)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0842 87.6757L47.0834 90.143L40.8281 86.5298L40.8289 84.0625L47.0842 87.6757Z",
    fill: "url(#paint344_linear_2723_72924)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0808 87.6756L47.0801 90.1429L48.9342 89.0646V86.627L47.0808 87.6756Z",
    fill: "url(#paint345_linear_2723_72924)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9347 86.6268L47.0814 87.6754L40.8291 84.0622L42.6885 83.0098L48.9347 86.6268Z",
    fill: "url(#paint346_linear_2723_72924)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4614 87.8348V139.269L45.124 137.923V86.4883L47.4614 87.8348Z",
    fill: "url(#paint347_linear_2723_72924)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4551 87.835V139.27L49.7742 137.923V86.4961L47.4551 87.835Z",
    fill: "url(#paint348_linear_2723_72924)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7745 86.4959L47.4553 87.8348L45.124 86.4883L47.4553 85.1426L49.7745 86.4959Z",
    fill: "url(#paint349_linear_2723_72924)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8354 129.143H31.5117V131.57H31.8354V129.143Z",
    fill: "url(#paint350_linear_2723_72924)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2359 128.949C32.2359 129.26 31.9844 129.511 31.6736 129.511C31.3628 129.511 31.1113 129.26 31.1113 128.949C31.1113 128.638 31.3628 128.387 31.6736 128.387C31.9844 128.387 32.2359 128.639 32.2359 128.949Z",
    fill: "url(#paint351_linear_2723_72924)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4588 132.252C32.4588 132.785 32.1077 132.847 31.6746 132.847C31.2415 132.847 30.8896 132.785 30.8896 132.252C30.8896 131.72 31.2407 130.918 31.6746 130.918C32.107 130.918 32.4588 131.72 32.4588 132.252Z",
    fill: "url(#paint352_linear_2723_72924)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3643 141.054C42.3643 142.489 42.8597 143.506 43.6644 143.997C43.6887 144.012 46.2077 145.471 46.2328 145.484C47.0702 145.953 46.5345 144.889 47.8073 144.155C50.368 142.677 52.4433 139.097 52.4433 136.158C52.4433 134.706 53.7867 134.693 52.9638 134.209C52.941 134.195 50.2602 132.712 50.2366 132.699C49.4015 132.247 48.2594 132.329 47.0003 133.057C44.4403 134.535 42.3643 138.115 42.3643 141.054Z",
    fill: "url(#paint353_linear_2723_72924)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0488 142.577C45.0488 145.515 47.1248 146.698 49.6848 145.22C52.2448 143.743 54.3208 140.162 54.3208 137.224C54.3208 134.285 52.2448 133.102 49.6848 134.58C47.1248 136.058 45.0488 139.639 45.0488 142.577Z",
    fill: "url(#paint354_linear_2723_72924)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4632 134.468C50.6904 133.759 51.8059 133.664 52.6349 134.078C51.8621 133.861 50.9024 134.023 49.8636 134.624C47.3028 136.102 45.2276 139.682 45.2276 142.621C45.2276 144.15 45.7907 145.203 46.6919 145.653C45.5597 145.336 44.8271 144.21 44.8271 142.465C44.8271 139.526 46.9024 135.946 49.4632 134.468Z",
    fill: "url(#paint355_radial_2723_72924)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7218 136.691C48.0698 137.645 46.7256 139.964 46.7256 141.86C46.7256 143.756 48.0698 144.523 49.7218 143.568C51.3737 142.615 52.7187 140.296 52.7187 138.4C52.7187 136.504 51.3745 135.738 49.7218 136.691Z",
    fill: "url(#paint356_linear_2723_72924)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6564 142.887C50.3084 141.933 51.6526 139.614 51.6526 137.718C51.6526 137.134 51.5242 136.657 51.2985 136.305C52.1488 136.421 52.7179 137.172 52.7179 138.403C52.7179 140.299 51.3737 142.619 49.721 143.572C48.5781 144.232 47.5834 144.068 47.0781 143.277C47.5379 143.34 48.0774 143.22 48.6564 142.887Z",
    fill: "url(#paint357_linear_2723_72924)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9248 141.057C47.9248 142.049 48.6254 142.448 49.4901 141.95C50.3549 141.451 51.0555 140.242 51.0555 139.25C51.0555 138.258 50.3549 137.859 49.4901 138.357C48.6254 138.856 47.9248 140.065 47.9248 141.057Z",
    fill: "url(#paint358_radial_2723_72924)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2197 141.222C48.2197 142.214 48.9203 142.613 49.7851 142.114C50.6498 141.615 51.3504 140.406 51.3504 139.414C51.3504 138.422 50.6498 138.023 49.7851 138.521C48.9211 139.02 48.2197 140.229 48.2197 141.222Z",
    fill: "url(#paint359_linear_2723_72924)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M55.539 133.446L50.4235 132.221L45.713 134.882L43.1963 133.408L48.1218 130.639L53.0481 132.005L55.539 133.446Z",
    fill: "url(#paint360_linear_2723_72924)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5389 133.446L54.51 134.007L50.4872 133.176L45.7646 135.756L45.7129 134.882L50.4234 132.221L55.5389 133.446Z",
    fill: "url(#paint361_linear_2723_72924)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1963 133.408V134.314L45.7647 135.757L45.713 134.882L43.1963 133.408Z",
    fill: "url(#paint362_linear_2723_72924)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1595 139.785L20.0341 149.568V157.074L2.72559 146.75V139.519L5.85096 129.461L23.1595 139.785Z",
    fill: "url(#paint363_linear_2723_72924)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0341 149.567V157.073L2.72559 146.749V139.518L20.0341 149.567Z",
    fill: "url(#paint364_linear_2723_72924)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M17.349 150.498L5.41211 143.568V146.989L17.349 154.108V150.498Z",
    fill: "url(#paint365_linear_2723_72924)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1529 139.784L20.0283 149.568V157.074L26.9402 153.046V146.719L26.9371 137.682L23.1529 139.784Z",
    fill: "url(#paint366_linear_2723_72924)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9364 137.681L23.1522 139.783L5.85059 129.46L9.6477 127.35L26.9364 137.681Z",
    fill: "url(#paint367_linear_2723_72924)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6465 153.597C19.6465 155.032 20.1419 156.049 20.9466 156.54C20.9709 156.555 23.4907 158.013 23.515 158.027C24.3524 158.495 23.8167 157.433 25.0895 156.698C27.6503 155.22 29.7255 151.64 29.7255 148.701C29.7255 147.249 31.069 147.237 30.246 146.752C30.2232 146.738 27.5424 145.255 27.5188 145.242C26.6837 144.79 25.5416 144.872 24.2825 145.6C21.7225 147.078 19.6465 150.659 19.6465 153.597Z",
    fill: "url(#paint368_linear_2723_72924)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M22.332 155.12C22.332 158.058 24.408 159.241 26.9681 157.763C29.5288 156.285 31.6041 152.705 31.6041 149.767C31.6041 146.828 29.5281 145.645 26.9681 147.123C24.4073 148.601 22.332 152.181 22.332 155.12Z",
    fill: "url(#paint369_linear_2723_72924)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7454 147.013C27.9726 146.304 29.0881 146.209 29.9171 146.623C29.1443 146.406 28.1846 146.568 27.1459 147.168C24.5851 148.646 22.5098 152.226 22.5098 155.165C22.5098 156.694 23.0729 157.747 23.9741 158.197C22.8419 157.881 22.1094 156.754 22.1094 155.009C22.1094 152.071 24.1854 148.491 26.7454 147.013Z",
    fill: "url(#paint370_radial_2723_72924)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M27.005 149.238C25.353 150.192 24.0088 152.511 24.0088 154.407C24.0088 156.303 25.353 157.07 27.005 156.115C28.657 155.161 30.002 152.842 30.002 150.947C30.0012 149.051 28.657 148.285 27.005 149.238Z",
    fill: "url(#paint371_linear_2723_72924)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9386 155.43C27.5906 154.476 28.9348 152.157 28.9348 150.261C28.9348 149.677 28.8064 149.2 28.5807 148.848C29.431 148.964 30.0002 149.715 30.0002 150.946C30.0002 152.842 28.6559 155.161 27.0032 156.115C25.8603 156.775 24.8657 156.611 24.3604 155.82C24.8208 155.883 25.3596 155.764 25.9386 155.43Z",
    fill: "url(#paint372_linear_2723_72924)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1748 153.633C25.1748 154.626 25.8754 155.025 26.7402 154.526C27.6049 154.028 28.3055 152.818 28.3055 151.826C28.3055 150.835 27.6049 150.434 26.7402 150.934C25.8754 151.432 25.1748 152.641 25.1748 153.633Z",
    fill: "url(#paint373_radial_2723_72924)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5029 153.764C25.5029 154.756 26.2035 155.156 27.0683 154.657C27.933 154.157 28.6336 152.949 28.6336 151.957C28.6336 150.964 27.933 150.566 27.0683 151.065C26.2035 151.563 25.5029 152.772 25.5029 153.764Z",
    fill: "url(#paint374_linear_2723_72924)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3882 111.027L48.2073 132.318L47.0721 131.665L40.2529 110.373L41.3882 111.027Z",
    fill: "url(#paint375_linear_2723_72924)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3848 111.027L48.2031 132.319L49.3293 131.666L42.5101 110.377L41.3848 111.027Z",
    fill: "url(#paint376_linear_2723_72924)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5105 110.377L41.3851 111.028L40.2529 110.374L41.3851 109.721L42.5105 110.377Z",
    fill: "url(#paint377_linear_2723_72924)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1821 117.674V118.879L12.2012 109.776V108.57L28.1821 117.674Z",
    fill: "url(#paint378_linear_2723_72924)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1768 117.675V118.88L42.4921 110.668V109.469L28.1768 117.675Z",
    fill: "url(#paint379_linear_2723_72924)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4922 109.469L28.1768 117.675L12.2012 108.571L26.5279 100.359L42.4922 109.469Z",
    fill: "url(#paint380_linear_2723_72924)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1134 126.196L39.5899 125.443L37.3262 124.098L35.7852 124.82V127.115L38.1461 128.427L38.1134 126.196Z",
    fill: "url(#paint381_linear_2723_72924)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3262 124.098V126.328L35.7852 127.115V124.82L37.3262 124.098Z",
    fill: "url(#paint382_linear_2723_72924)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4448 124.123H37.1211V126.55H37.4448V124.123Z",
    fill: "url(#paint383_linear_2723_72924)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6147 126.326H36.9521V127.54H37.6147V126.326Z",
    fill: "url(#paint384_linear_2723_72924)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8453 123.931C37.8453 124.242 37.5938 124.494 37.283 124.494C36.9722 124.494 36.7207 124.242 36.7207 123.931C36.7207 123.621 36.9722 123.369 37.283 123.369C37.5938 123.369 37.8453 123.621 37.8453 123.931Z",
    fill: "url(#paint385_linear_2723_72924)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0276 149.566L22.8946 139.812L5.85059 129.459L23.1241 139.419L26.9364 137.68L23.2882 139.878L20.0276 149.566Z",
    fill: "url(#paint386_radial_2723_72924)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1768 118.881L27.9671 117.675L12.2012 108.572L28.1419 117.413L42.4922 109.47L28.404 117.762L28.1768 118.881Z",
    fill: "url(#paint387_radial_2723_72924)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4235 132.221L45.8095 134.861L43.1963 133.408L45.7875 134.565L50.4235 132.221Z",
    fill: "url(#paint388_radial_2723_72924)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4789 131.562L22.4873 126.162L24.7829 130.823L27.4615 129.815L24.4789 131.562Z",
    fill: "url(#paint389_radial_2723_72924)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M45.124 86.4883L47.5146 87.5187L49.7745 86.4959L47.6453 87.9997L47.4705 123.841L47.2524 87.8682L45.124 86.4883Z",
    fill: "url(#paint390_radial_2723_72924)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M190.728 148.398L154.445 169.355L166.695 176.436L178.309 169.727L190.39 176.71L178.775 183.419L190.724 190.326L227.008 169.37L190.728 148.398Z",
    fill: "url(#paint391_linear_2723_72924)"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.672 149.605L178.172 156.253L166.671 162.896L155.171 156.248L166.672 149.605Z",
    fill: "url(#paint392_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.182 169.454L166.675 176.096V162.893L178.182 156.25V169.454Z",
    fill: "url(#paint393_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.677 176.096L155.171 169.454V156.25L166.677 162.893V176.096Z",
    fill: "url(#paint394_linear_2723_72924)"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.672 135.9L178.172 142.548L166.671 149.191L155.171 142.543L166.672 135.9Z",
    fill: "url(#paint395_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.182 155.747L166.675 162.39V149.187L178.182 142.543V155.747Z",
    fill: "url(#paint396_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.677 162.39L155.171 155.747V142.543L166.677 149.187V162.39Z",
    fill: "url(#paint397_linear_2723_72924)"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.672 122.195L178.172 128.842L166.671 135.485L155.171 128.837L166.672 122.195Z",
    fill: "url(#paint398_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.182 142.042L166.675 148.684V135.481L178.182 128.838V142.042Z",
    fill: "url(#paint399_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.677 148.684L155.171 142.042V128.838L166.677 135.481V148.684Z",
    fill: "url(#paint400_linear_2723_72924)"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.673 125.693L175.137 130.586L166.672 135.475L158.209 130.582L166.673 125.693Z",
    fill: "url(#paint401_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.144 140.3L166.675 145.189V135.472L175.144 130.582V140.3Z",
    fill: "url(#paint402_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.677 145.189L158.208 140.3V130.582L166.677 135.472V145.189Z",
    fill: "url(#paint403_linear_2723_72924)"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.672 108.49L178.172 115.138L166.671 121.78L155.171 115.133L166.672 108.49Z",
    fill: "url(#paint404_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.182 128.336L166.675 134.979V121.776L178.182 115.133V128.336Z",
    fill: "url(#paint405_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.677 134.979L155.171 128.336V115.133L166.677 121.776V134.979Z",
    fill: "url(#paint406_linear_2723_72924)"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.182 114.631L166.675 121.275V108.071L178.182 101.428V114.631Z",
    fill: "url(#paint407_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.677 121.274L155.171 114.63L166.677 108.07V121.274Z",
    fill: "url(#paint408_linear_2723_72924)"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.655 129.129L190.154 135.776L178.653 142.419L167.153 135.772L178.655 129.129Z",
    fill: "url(#paint409_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.164 148.975L178.657 155.619V142.415L190.164 135.771V148.975Z",
    fill: "url(#paint410_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.659 155.619L167.153 148.975V135.771L178.659 142.415V155.619Z",
    fill: "url(#paint411_linear_2723_72924)"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.669 163.463L202.168 170.11L190.667 176.753L179.168 170.106L190.669 163.463Z",
    fill: "url(#paint412_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.178 183.309L190.671 189.952V176.748L202.178 170.105V183.309Z",
    fill: "url(#paint413_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.673 189.952L179.167 183.309V170.105L190.673 176.748V189.952Z",
    fill: "url(#paint414_linear_2723_72924)"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.669 166.959L199.133 171.852L190.669 176.741L182.205 171.849L190.669 166.959Z",
    fill: "url(#paint415_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.141 181.567L190.672 186.457V176.739L199.141 171.85V181.567Z",
    fill: "url(#paint416_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.673 186.457L182.204 181.567V171.85L190.673 176.739V186.457Z",
    fill: "url(#paint417_linear_2723_72924)"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.669 149.756L202.168 156.403L190.667 163.046L179.168 156.399L190.669 149.756Z",
    fill: "url(#paint418_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.178 169.602L190.671 176.246V163.042L202.178 156.398V169.602Z",
    fill: "url(#paint419_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.673 176.246L179.167 169.602V156.398L190.673 163.042V176.246Z",
    fill: "url(#paint420_linear_2723_72924)"
  }))), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M166.794 121.527L166.467 135.743L178.776 142.476L167.198 135.256L166.794 121.527Z",
    fill: "url(#paint421_radial_2723_72924)"
  })), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.669 122.408L202.168 129.056L190.667 135.698L179.168 129.051L190.669 122.408Z",
    fill: "url(#paint422_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.178 142.254L190.671 148.898V135.694L202.178 129.051V142.254Z",
    fill: "url(#paint423_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.673 148.898L179.167 142.254V129.051L190.673 135.694V148.898Z",
    fill: "url(#paint424_linear_2723_72924)"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.668 108.703L179.167 115.346L190.672 135.192L202.178 128.55L190.668 108.703Z",
    fill: "url(#paint425_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.673 135.192L179.167 128.549V115.346L190.673 135.192Z",
    fill: "url(#paint426_linear_2723_72924)"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.626 78.541L190.126 85.1884L178.625 91.8313L167.125 85.1839L178.626 78.541Z",
    fill: "url(#paint427_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.136 98.3872L178.629 105.03V91.8264L190.136 85.1836V98.3872Z",
    fill: "url(#paint428_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.631 105.03L167.125 98.3872V85.1836L178.631 91.8264V105.03Z",
    fill: "url(#paint429_linear_2723_72924)"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.627 82.0391L187.091 86.9312L178.626 91.8202L170.162 86.9274L178.627 82.0391Z",
    fill: "url(#paint430_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.098 96.645L178.629 101.535V91.8168L187.098 86.9277V96.645Z",
    fill: "url(#paint431_linear_2723_72924)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.631 101.535L170.162 96.645V86.9277L178.631 91.8168V101.535Z",
    fill: "url(#paint432_linear_2723_72924)"
  }))), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M178.631 92.1031C178.473 92.1031 178.346 91.9755 178.346 91.8182V60.1404C178.346 59.9831 178.473 59.8555 178.631 59.8555C178.788 59.8555 178.916 59.9831 178.916 60.1404V91.8182C178.916 91.9755 178.788 92.1031 178.631 92.1031Z",
    fill: "#8969C3"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M167.125 85.4708C167.052 85.4708 166.98 85.4434 166.924 85.3887C166.813 85.2778 166.812 85.0977 166.922 84.9852L178.578 73.2246L190.338 84.9845C190.448 85.0954 190.448 85.2763 190.338 85.3872C190.227 85.4981 190.045 85.4981 189.934 85.3872L178.58 74.0324L167.328 85.3864C167.272 85.4427 167.199 85.4708 167.125 85.4708Z",
    fill: "#8969C3"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M154.233 14.7762L156.349 13.834L159.015 24.8689L158.583 24.9951L154.109 22.2131C153.859 22.0581 153.708 21.7846 153.709 21.4897L153.73 15.549C153.731 15.2147 153.929 14.9122 154.233 14.7762Z",
    fill: "url(#paint433_linear_2723_72924)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M153.806 14.9286L155.921 13.9863L158.588 25.0213L153.723 22.3579C153.45 22.2082 153.281 21.9217 153.282 21.6109L153.304 15.7014C153.304 15.367 153.5 15.0646 153.806 14.9286Z",
    fill: "url(#paint434_linear_2723_72924)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M147.364 25.525L154.395 20.9824L157.973 22.3791V22.8662L151.745 28.0668L147.364 25.525Z",
    fill: "url(#paint435_linear_2723_72924)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M147.364 25.0113L154.395 20.4688L157.973 22.3525L151.745 27.5531L147.364 25.0113Z",
    fill: "url(#paint436_linear_2723_72924)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M193.636 74.2091C193.566 73.9804 193.321 73.852 193.095 73.9226L192.111 74.2251C191.065 74.5473 189.922 74.4158 188.975 73.8649L184.21 71.0898V68.8391C184.21 67.1803 185.1 65.6301 186.532 64.7942L187.456 64.2555L187.02 63.5085L186.096 64.0473C184.399 65.0382 183.344 66.874 183.344 68.8398V70.5868L172.168 64.0792V61.6294C172.168 59.9698 173.058 58.4204 174.491 57.5845L175.415 57.0465L174.979 56.2988L174.056 56.8368C172.358 57.8277 171.304 59.6636 171.304 61.6294V63.5754L167.844 61.561C167.637 61.4409 167.373 61.5108 167.252 61.7168C167.132 61.9234 167.202 62.1879 167.408 62.3087L188.54 74.6134C189.279 75.0435 190.116 75.2646 190.958 75.2646C191.431 75.2646 191.906 75.1947 192.366 75.0534L193.35 74.7509C193.578 74.6795 193.706 74.4378 193.636 74.2091Z",
    fill: "#653FAB"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M130.132 16.0622V2.19973C130.132 1.81903 130.364 1.47708 130.718 1.33726L131.85 0.888933C132.451 0.650332 133.124 1.00748 133.262 1.6397L136.782 17.6845L162.559 32.3934C162.559 32.3934 187.218 41.749 189.705 43.5872C192.193 45.4261 196.839 48.5499 199.655 50.942C202.287 53.1768 204.448 58.1411 206.938 61.3432C208.831 63.7764 211.318 68.3189 206.199 70.7885C201.056 73.2695 189.903 68.4268 179.521 61.7216C169.138 55.0165 168.02 52.4565 165.641 46.6161C163.262 40.7756 161.639 38.1799 157.259 35.4763C152.879 32.7726 135.321 21.4163 135.321 21.4163L131.722 24.6313C131.394 24.9634 130.871 24.9991 130.5 24.7156L128.255 22.9968C127.921 22.7407 127.801 22.2909 127.964 21.9026L130.132 16.0622Z",
    fill: "url(#paint437_radial_2723_72924)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M161.568 32.8965C161.568 32.8965 170.599 43.8744 182.496 50.1472C189.167 53.6647 193.282 53.4724 196.178 50.7422C198.071 48.9572 195.204 46.686 191.96 43.6039C188.126 39.9618 184.264 38.6252 181.252 37.3851C175.737 35.1138 161.568 32.8965 161.568 32.8965Z",
    fill: "url(#paint438_radial_2723_72924)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M189.688 55.1498C189.663 54.6559 190.066 54.2516 190.56 54.2722C191.574 54.314 193.299 54.2243 195.016 53.3915C198.585 51.6612 199.099 50.4355 199.099 50.4355C199.099 50.4355 201.92 52.4264 202.992 53.9599C204.416 55.9971 206.588 60.855 206.588 60.855C206.588 60.855 204.615 61.2874 202.559 62.3694C200.989 63.1954 196.845 65.9925 194.177 64.6946C191.646 63.4614 189.974 60.9796 189.688 55.1498Z",
    fill: "url(#paint439_linear_2723_72924)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M206.345 70.6612C207.151 70.2281 207.789 69.7813 208.285 69.3238C206.105 70.1681 203.218 70.0138 200.649 69.1468C178.674 61.7296 172.709 52.1666 170.33 46.9751C169.086 44.2593 169.242 38.5929 169.576 34.4371C165.948 33.0298 163.319 32.0321 163.319 32.0321L137.542 17.3232L134.022 1.27836C133.884 0.646146 133.211 0.289005 132.61 0.527606L130.891 1.20846L130.713 1.29736C130.383 1.46225 130.182 1.80648 130.2 2.17502L130.89 15.7008L128.674 21.6613C128.536 21.9911 128.599 22.3703 128.837 22.637L130.675 24.697C130.947 25.0017 131.387 25.0929 131.758 24.9204C131.858 24.8741 131.949 24.8102 132.026 24.732L136.082 21.0549C136.082 21.0549 153.639 32.4113 158.02 35.1149C162.399 37.8186 164.022 40.4143 166.402 46.2547C168.781 52.0951 169.899 54.6544 180.282 61.3603C190.663 68.0655 201.316 73.3649 206.345 70.6612Z",
    fill: "url(#paint440_linear_2723_72924)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M185.502 53.0223L187.784 53.8947C188.097 54.014 188.309 54.3088 188.319 54.6439C188.337 55.21 188.387 56.1971 188.526 57.5292C188.694 59.1386 189.043 60.4661 189.316 61.3156C189.429 61.669 189.047 61.976 188.724 61.7921L185.027 59.6834C184.502 59.384 184.186 58.8179 184.209 58.2138L184.373 53.7693C184.395 53.1994 184.97 52.8187 185.502 53.0223Z",
    fill: "url(#paint441_linear_2723_72924)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M206.201 70.7885C207.007 70.3554 207.645 69.9086 208.141 69.4511C205.96 70.2953 203.506 70.5917 200.938 69.7247C178.963 62.3075 171.953 52.5279 169.574 47.3364C168.329 44.6206 168.486 38.9542 168.819 34.7984C165.191 33.3911 162.562 32.3934 162.562 32.3934L136.785 17.6845L133.264 1.6397C133.126 1.00748 132.454 0.650332 131.853 0.888933L130.72 1.33726C130.366 1.47708 130.135 1.81979 130.135 2.19973V16.0622L127.969 21.9018C127.805 22.2909 127.926 22.74 128.26 22.9968L130.505 24.7156C130.875 24.9991 131.399 24.9634 131.727 24.6313L135.326 21.4162C135.326 21.4162 148.791 30.1769 153.172 32.8805C157.552 35.5842 161.68 40.2354 164.708 46.5803C167.425 52.2718 169.143 55.0165 179.525 61.7216C189.906 68.4268 201.172 73.4921 206.201 70.7885Z",
    fill: "url(#paint442_radial_2723_72924)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M162.002 31.9227C162.002 31.9227 172.061 40.9234 177.703 43.6939C183.795 46.6863 186.229 46.5237 188.987 44.8474C190.955 43.6514 190.581 40.6947 182.551 36.6278C174.331 32.4637 169.897 30.7874 162.002 31.9227Z",
    fill: "url(#paint443_radial_2723_72924)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M168.437 31.9775C168.437 31.9775 179.63 45.6051 187.49 42.3422C191.895 40.5139 172.979 31.1667 168.437 31.9775Z",
    fill: "url(#paint444_linear_2723_72924)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M137.009 30.0396L137.018 29.5259L146.743 25.7676L151.096 27.7775L151.123 28.3094L140.686 32.3109L137.009 30.0396Z",
    fill: "url(#paint445_linear_2723_72924)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M137.009 29.5259L146.743 25.2539L151.123 27.7957L140.686 31.7972L137.009 29.5259Z",
    fill: "url(#paint446_linear_2723_72924)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M184.246 39.2417C184.246 40.048 182.89 40.7015 181.218 40.7015C179.545 40.7015 178.189 40.048 178.189 39.2417C178.189 38.4355 179.545 37.7812 181.218 37.7812C182.889 37.782 184.246 38.4355 184.246 39.2417Z",
    fill: "#694599"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M179.549 40.4385C180.027 40.6019 180.604 40.6968 181.227 40.6968C181.862 40.6968 182.45 40.5965 182.933 40.4271V35.1543H179.549V40.4385Z",
    fill: "url(#paint447_linear_2723_72924)"
  })), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.064 34.7885C226.064 20.3721 205.997 8.6875 181.241 8.6875C168.655 8.6875 157.298 11.7186 149.156 16.5834L212.892 53.2687C221.029 48.543 226.064 42.0089 226.064 34.7885Z",
    fill: "#B086CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M136.418 34.7887C136.418 49.2051 156.487 60.8897 181.241 60.8897C193.598 60.8897 204.785 57.9778 212.892 53.2674L149.156 16.582C141.284 21.2857 136.418 27.7036 136.418 34.7887Z",
    fill: "#B086CC"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.418 34.7885C136.418 20.3721 156.486 8.6875 181.241 8.6875C193.827 8.6875 205.185 11.7186 213.326 16.5834L149.59 53.2687C141.453 48.543 136.418 42.0089 136.418 34.7885Z",
    fill: "#B086CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M226.065 34.7887C226.065 49.2051 205.996 60.8897 181.242 60.8897C168.885 60.8897 157.698 57.9778 149.591 53.2674L213.327 16.582C221.199 21.2857 226.065 27.7036 226.065 34.7887Z",
    fill: "#B086CC"
  }))), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M183.806 33.2852H178.676V34.3566V34.3771C178.676 35.2023 179.825 35.871 181.241 35.871C182.658 35.871 183.806 35.2023 183.806 34.3771L183.806 34.3634L183.806 34.3566V33.2852Z",
    fill: "url(#paint448_linear_2723_72924)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M178.676 33.2966C178.676 34.1219 179.825 34.7906 181.241 34.7906C182.658 34.7906 183.806 34.1219 183.806 33.2966C183.806 32.4714 182.658 31.8027 181.241 31.8027C179.824 31.8027 178.676 32.4714 178.676 33.2966Z",
    fill: "url(#paint449_linear_2723_72924)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M136.857 24.2938L138.972 23.3516L141.638 34.3865L141.207 34.5126L136.733 31.7307C136.483 31.5757 136.332 31.3022 136.333 31.0073L136.354 25.0666C136.354 24.7323 136.552 24.4298 136.857 24.2938Z",
    fill: "url(#paint450_linear_2723_72924)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M136.429 24.4462L138.544 23.5039L141.211 34.5388L136.346 31.8755C136.073 31.7258 135.904 31.4393 135.904 31.1285L135.926 25.219C135.926 24.8846 136.123 24.5822 136.429 24.4462Z",
    fill: "url(#paint451_linear_2723_72924)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M203.017 54.3952C202.01 52.9552 199.36 51.0859 199.36 51.0859C199.36 51.0859 198.878 52.2372 195.526 53.8618C193.913 54.6437 192.293 54.728 191.341 54.6885C191.129 54.6794 190.938 54.7569 190.791 54.8846C193.396 56.7394 196.387 57.5791 203.964 57.7546C204.297 57.7622 204.605 57.7493 204.894 57.7204C204.283 56.5031 203.586 55.209 203.017 54.3952Z",
    fill: "url(#paint452_linear_2723_72924)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M185.9 132.262L186.469 133.301L194.203 129.098L201.937 124.895C202.225 124.739 202.33 124.379 202.174 124.091C202.017 123.805 201.659 123.699 201.372 123.855L193.637 128.059L185.9 132.262Z",
    fill: "black"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M202.098 124.129C202.169 124.259 202.182 124.404 202.15 124.537C202.112 124.688 202.009 124.827 201.862 124.907L194.522 128.894L194.348 128.988L186.83 133.072L186.308 132.072L193.542 128.137L193.811 127.99L201.32 123.907C201.452 123.835 201.606 123.819 201.742 123.854C201.887 123.891 202.02 123.986 202.098 124.129Z",
    fill: "url(#paint453_linear_2723_72924)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M202.022 124.168C202.091 124.294 202.101 124.436 202.069 124.563C202.032 124.706 201.927 124.843 201.788 124.918L194.661 128.788L194.493 128.879L187.192 132.842L186.714 131.882L193.727 128.063L193.987 127.922L201.267 123.959C201.392 123.89 201.547 123.872 201.674 123.904C201.817 123.94 201.946 124.029 202.022 124.168Z",
    fill: "url(#paint454_linear_2723_72924)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M201.946 124.208C202.013 124.331 202.02 124.467 201.989 124.591C201.953 124.725 201.846 124.86 201.714 124.932L194.801 128.682L194.64 128.77L187.555 132.613L187.123 131.692L193.915 127.991L194.166 127.854L201.219 124.011C201.337 123.946 201.491 123.925 201.612 123.955C201.747 123.989 201.872 124.074 201.946 124.208Z",
    fill: "url(#paint455_linear_2723_72924)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M201.87 124.248C201.934 124.366 201.94 124.499 201.907 124.617C201.872 124.744 201.763 124.876 201.639 124.944L194.939 128.577L194.784 128.661L187.916 132.385L187.529 131.503L194.099 127.919L194.34 127.788L201.165 124.064C201.278 124.004 201.43 123.98 201.545 124.007C201.676 124.037 201.799 124.118 201.87 124.248Z",
    fill: "url(#paint456_linear_2723_72924)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M201.794 124.284C201.857 124.399 201.86 124.527 201.827 124.64C201.793 124.759 201.682 124.889 201.565 124.953L195.079 128.468L194.93 128.548L188.278 132.152L187.937 131.309L194.285 127.842L194.516 127.716L201.114 124.113C201.22 124.055 201.371 124.029 201.48 124.054C201.607 124.083 201.726 124.159 201.794 124.284Z",
    fill: "url(#paint457_linear_2723_72924)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M201.719 124.323C201.78 124.434 201.779 124.558 201.746 124.667C201.713 124.778 201.601 124.905 201.49 124.965L195.217 128.362L195.075 128.44L188.64 131.924L188.344 131.12L194.47 127.77L194.693 127.649L201.063 124.165C201.161 124.111 201.312 124.083 201.414 124.105C201.536 124.132 201.652 124.202 201.719 124.323Z",
    fill: "url(#paint458_linear_2723_72924)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M201.643 124.363C201.702 124.47 201.698 124.59 201.666 124.694C201.633 124.797 201.518 124.922 201.416 124.978L195.357 128.257L195.221 128.33L189.002 131.695L188.751 130.93L194.654 127.697L194.867 127.581L201.01 124.218C201.103 124.168 201.252 124.137 201.348 124.156C201.465 124.18 201.579 124.247 201.643 124.363Z",
    fill: "url(#paint459_linear_2723_72924)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M201.567 124.402C201.623 124.505 201.618 124.62 201.585 124.72C201.554 124.816 201.437 124.938 201.342 124.99L195.496 128.151L195.366 128.221L189.364 131.465L189.158 130.74L194.841 127.624L195.044 127.513L200.959 124.269C201.045 124.222 201.194 124.189 201.283 124.206C201.395 124.228 201.505 124.289 201.567 124.402Z",
    fill: "url(#paint460_linear_2723_72924)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M201.491 124.442C201.546 124.542 201.538 124.653 201.505 124.748C201.474 124.835 201.356 124.956 201.268 125.004L195.635 128.047L195.512 128.114L189.727 131.239L189.566 130.552L195.027 127.554L195.221 127.448L200.909 124.324C200.988 124.28 201.136 124.245 201.219 124.259C201.325 124.278 201.432 124.335 201.491 124.442Z",
    fill: "url(#paint461_linear_2723_72924)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M201.415 124.48C201.467 124.576 201.456 124.683 201.423 124.773C201.394 124.853 201.273 124.971 201.192 125.015L195.773 127.939L195.656 128.003L190.087 131.008L189.972 130.36L195.21 127.478L195.395 127.376L200.855 124.373C200.927 124.333 201.075 124.294 201.15 124.307C201.254 124.326 201.358 124.378 201.415 124.48Z",
    fill: "url(#paint462_linear_2723_72924)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M201.339 124.519C201.389 124.611 201.375 124.712 201.342 124.798C201.315 124.871 201.191 124.986 201.117 125.026L195.912 127.833L195.801 127.893L190.449 130.779L190.379 130.17L195.396 127.406L195.571 127.31L200.804 124.426C200.87 124.39 201.016 124.348 201.086 124.359C201.184 124.374 201.285 124.421 201.339 124.519Z",
    fill: "url(#paint463_linear_2723_72924)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M201.262 124.559C201.311 124.648 201.294 124.744 201.262 124.826C201.236 124.891 201.109 125.004 201.043 125.04L196.05 127.729L195.945 127.785L190.81 130.551L190.785 129.981L195.58 127.334L195.746 127.243L200.751 124.48C200.81 124.448 200.957 124.403 201.019 124.411C201.114 124.423 201.211 124.465 201.262 124.559Z",
    fill: "url(#paint464_linear_2723_72924)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M201.186 124.597C201.233 124.681 201.214 124.773 201.18 124.851C201.156 124.908 201.027 125.018 200.968 125.05L196.19 127.621L196.092 127.674L191.173 130.32L191.193 129.789L195.766 127.26L195.923 127.173L200.7 124.529C200.753 124.501 200.899 124.469 200.954 124.459C201.044 124.444 201.138 124.507 201.186 124.597Z",
    fill: "url(#paint465_linear_2723_72924)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M201.111 124.635C201.155 124.716 201.148 124.811 201.1 124.876C201.088 124.929 200.945 125.033 200.895 125.062L196.329 127.514L196.237 127.564L191.535 130.09L191.601 129.599L195.952 127.186L196.1 127.105L200.649 124.581C200.695 124.556 200.841 124.521 200.889 124.51C200.973 124.489 201.065 124.55 201.111 124.635Z",
    fill: "url(#paint466_linear_2723_72924)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M201.035 124.674C201.077 124.751 201.067 124.842 201.02 124.902C201.009 124.947 200.864 125.049 200.82 125.073L196.468 127.408L196.382 127.454L191.896 129.861L192.007 129.409L196.136 127.113L196.274 127.036L200.596 124.633C200.636 124.611 200.782 124.549 200.822 124.56C200.904 124.551 200.991 124.593 201.035 124.674Z",
    fill: "url(#paint467_linear_2723_72924)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M200.959 124.713C200.999 124.786 200.988 124.874 200.939 124.928C200.93 124.966 200.782 125.065 200.745 125.085L196.607 127.301L196.528 127.344L192.259 129.63L192.415 129.217L196.323 127.038L196.451 126.967L200.545 124.684C200.578 124.665 200.724 124.601 200.757 124.609C200.834 124.599 200.918 124.637 200.959 124.713Z",
    fill: "url(#paint468_linear_2723_72924)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M200.883 124.753C200.921 124.822 200.908 124.905 200.858 124.955C200.851 124.985 200.7 125.082 200.67 125.098L196.746 127.197L196.673 127.235L192.621 129.403L192.822 129.029L196.508 126.967L196.627 126.9L200.494 124.737C200.521 124.722 200.665 124.654 200.693 124.662C200.764 124.647 200.844 124.681 200.883 124.753Z",
    fill: "url(#paint469_linear_2723_72924)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M200.808 124.792C200.844 124.857 200.829 124.936 200.778 124.981C200.773 125.004 200.619 125.098 200.597 125.11L196.885 127.091L196.818 127.126L192.983 129.173L193.23 128.838L196.694 126.894L196.804 126.833L200.443 124.79C200.463 124.779 200.607 124.708 200.627 124.713C200.694 124.693 200.771 124.724 200.808 124.792Z",
    fill: "url(#paint470_linear_2723_72924)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M200.732 124.829C200.765 124.891 200.749 124.966 200.697 125.006C200.693 125.021 200.536 125.112 200.522 125.121L197.024 126.984L196.964 127.016L193.346 128.943L193.638 128.646L196.88 126.82L196.98 126.763L200.392 124.84C200.405 124.833 200.549 124.758 200.562 124.762C200.624 124.739 200.697 124.766 200.732 124.829Z",
    fill: "url(#paint471_linear_2723_72924)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M200.655 124.869C200.687 124.927 200.669 124.999 200.616 125.033C200.614 125.04 200.454 125.129 200.447 125.133L197.163 126.878L197.109 126.907L193.707 128.714L194.044 128.458L197.064 126.748L197.155 126.696L200.339 124.893C200.346 124.889 200.489 124.812 200.496 124.813C200.553 124.787 200.623 124.811 200.655 124.869Z",
    fill: "url(#paint472_linear_2723_72924)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M194.068 128.484L197.248 126.674L200.429 124.863C200.482 124.834 200.549 124.854 200.579 124.907C200.609 124.961 200.589 125.029 200.535 125.058L197.302 126.771L194.068 128.484Z",
    fill: "url(#paint473_linear_2723_72924)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M180.296 128.917L180.864 129.955L188.598 125.753L196.332 121.55C196.62 121.393 196.726 121.033 196.569 120.746C196.412 120.459 196.054 120.354 195.767 120.509L188.031 124.713L180.296 128.917Z",
    fill: "black"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M196.493 120.784C196.565 120.914 196.578 121.059 196.545 121.192C196.508 121.341 196.404 121.481 196.258 121.561L188.917 125.548L188.743 125.642L181.226 129.726L180.703 128.727L187.939 124.791L188.208 124.645L195.716 120.561C195.848 120.49 196.002 120.473 196.138 120.508C196.284 120.545 196.415 120.64 196.493 120.784Z",
    fill: "url(#paint474_linear_2723_72924)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M196.417 120.823C196.486 120.949 196.497 121.09 196.464 121.218C196.428 121.36 196.323 121.497 196.183 121.573L189.056 125.442L188.888 125.533L181.587 129.497L181.109 128.536L188.122 124.718L188.382 124.576L195.663 120.613C195.788 120.545 195.941 120.526 196.07 120.558C196.213 120.594 196.341 120.684 196.417 120.823Z",
    fill: "url(#paint475_linear_2723_72924)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M196.341 120.863C196.408 120.985 196.416 121.122 196.383 121.245C196.347 121.379 196.24 121.514 196.109 121.586L189.195 125.337L189.034 125.424L181.95 129.268L181.518 128.346L188.309 124.645L188.56 124.509L195.613 120.665C195.732 120.6 195.885 120.579 196.007 120.609C196.142 120.643 196.268 120.728 196.341 120.863Z",
    fill: "url(#paint476_linear_2723_72924)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M196.266 120.902C196.331 121.02 196.336 121.153 196.303 121.271C196.268 121.398 196.16 121.53 196.035 121.598L189.335 125.231L189.18 125.315L182.313 129.039L181.926 128.157L188.495 124.574L188.736 124.442L195.561 120.719C195.673 120.658 195.825 120.634 195.941 120.662C196.072 120.691 196.195 120.772 196.266 120.902Z",
    fill: "url(#paint477_linear_2723_72924)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M196.19 120.938C196.253 121.053 196.255 121.181 196.223 121.295C196.188 121.413 196.077 121.543 195.96 121.607L189.474 125.122L189.325 125.203L182.674 128.807L182.332 127.963L188.68 124.497L188.912 124.371L195.51 120.767C195.615 120.71 195.767 120.684 195.875 120.709C196.001 120.738 196.121 120.813 196.19 120.938Z",
    fill: "url(#paint478_linear_2723_72924)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M196.114 120.979C196.175 121.09 196.174 121.214 196.141 121.322C196.108 121.433 195.995 121.561 195.885 121.621L189.612 125.018L189.47 125.096L183.036 128.58L182.739 127.776L188.865 124.426L189.088 124.305L195.458 120.821C195.557 120.768 195.707 120.739 195.81 120.761C195.931 120.787 196.048 120.858 196.114 120.979Z",
    fill: "url(#paint479_linear_2723_72924)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M196.038 121.018C196.097 121.125 196.094 121.245 196.061 121.349C196.028 121.452 195.914 121.577 195.811 121.633L189.751 124.912L189.615 124.985L183.397 128.35L183.146 127.585L189.05 124.352L189.263 124.236L195.405 120.872C195.498 120.822 195.648 120.791 195.744 120.811C195.861 120.835 195.975 120.902 196.038 121.018Z",
    fill: "url(#paint480_linear_2723_72924)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M195.962 121.057C196.019 121.16 196.013 121.276 195.981 121.375C195.95 121.471 195.833 121.594 195.738 121.645L189.891 124.806L189.761 124.876L183.76 128.121L183.554 127.395L189.235 124.28L189.439 124.168L195.354 120.925C195.44 120.879 195.589 120.845 195.678 120.862C195.791 120.884 195.901 120.945 195.962 121.057Z",
    fill: "url(#paint481_linear_2723_72924)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M195.887 121.097C195.941 121.196 195.933 121.307 195.9 121.402C195.87 121.489 195.751 121.61 195.663 121.658L190.03 124.701L189.907 124.768L184.122 127.894L183.962 127.207L189.422 124.208L189.617 124.102L195.305 120.978C195.384 120.935 195.532 120.899 195.615 120.913C195.721 120.932 195.828 120.989 195.887 121.097Z",
    fill: "url(#paint482_linear_2723_72924)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M195.81 121.135C195.863 121.231 195.851 121.337 195.819 121.427C195.79 121.507 195.668 121.626 195.588 121.669L190.168 124.594L190.051 124.657L184.483 127.662L184.367 127.014L189.606 124.132L189.79 124.031L195.25 121.027C195.323 120.987 195.471 120.949 195.546 120.962C195.65 120.981 195.754 121.032 195.81 121.135Z",
    fill: "url(#paint483_linear_2723_72924)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M195.734 121.173C195.784 121.265 195.771 121.367 195.738 121.453C195.711 121.525 195.587 121.64 195.513 121.681L190.307 124.488L190.196 124.548L184.844 127.433L184.774 126.824L189.791 124.061L189.967 123.964L195.199 121.08C195.265 121.045 195.412 121.003 195.481 121.013C195.58 121.028 195.68 121.075 195.734 121.173Z",
    fill: "url(#paint484_linear_2723_72924)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M195.659 121.214C195.707 121.302 195.691 121.398 195.657 121.48C195.631 121.545 195.505 121.658 195.438 121.694L190.446 124.383L190.342 124.439L185.207 127.205L185.182 126.635L189.976 123.989L190.143 123.898L195.147 121.134C195.207 121.102 195.353 121.057 195.416 121.065C195.51 121.078 195.607 121.119 195.659 121.214Z",
    fill: "url(#paint485_linear_2723_72924)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M195.583 121.251C195.629 121.335 195.61 121.427 195.577 121.505C195.553 121.562 195.423 121.673 195.365 121.704L190.586 124.275L190.488 124.328L185.569 126.974L185.59 126.443L190.163 123.914L190.319 123.827L195.097 121.183C195.15 121.155 195.296 121.123 195.35 121.114C195.439 121.098 195.534 121.161 195.583 121.251Z",
    fill: "url(#paint486_linear_2723_72924)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M195.508 121.29C195.552 121.371 195.544 121.466 195.497 121.531C195.485 121.583 195.342 121.688 195.291 121.716L190.726 124.169L190.634 124.219L185.932 126.744L185.997 126.253L190.348 123.84L190.495 123.759L195.045 121.235C195.091 121.21 195.237 121.175 195.285 121.164C195.369 121.144 195.46 121.205 195.508 121.29Z",
    fill: "url(#paint487_linear_2723_72924)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M195.431 121.328C195.473 121.405 195.464 121.496 195.416 121.556C195.405 121.601 195.26 121.703 195.216 121.727L190.864 124.062L190.779 124.108L186.293 126.515L186.404 126.063L190.533 123.767L190.671 123.691L194.993 121.287C195.032 121.266 195.178 121.203 195.218 121.214C195.301 121.205 195.387 121.248 195.431 121.328Z",
    fill: "url(#paint488_linear_2723_72924)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M195.355 121.368C195.395 121.44 195.384 121.528 195.335 121.583C195.325 121.62 195.177 121.719 195.141 121.739L191.003 123.956L190.924 123.998L186.655 126.285L186.812 125.871L190.719 123.693L190.848 123.621L194.942 121.338C194.974 121.32 195.12 121.255 195.154 121.263C195.23 121.253 195.313 121.292 195.355 121.368Z",
    fill: "url(#paint489_linear_2723_72924)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M195.279 121.407C195.317 121.476 195.304 121.56 195.254 121.609C195.247 121.64 195.096 121.736 195.066 121.752L191.141 123.851L191.068 123.89L187.017 126.057L187.218 125.683L190.903 123.621L191.023 123.555L194.89 121.391C194.916 121.377 195.061 121.308 195.088 121.316C195.159 121.301 195.239 121.336 195.279 121.407Z",
    fill: "url(#paint490_linear_2723_72924)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M195.203 121.446C195.239 121.512 195.225 121.591 195.174 121.635C195.168 121.658 195.014 121.752 194.992 121.764L191.281 123.745L191.214 123.781L187.379 125.828L187.626 125.493L191.089 123.549L191.2 123.487L194.839 121.444C194.858 121.433 195.003 121.362 195.022 121.367C195.09 121.347 195.167 121.379 195.203 121.446Z",
    fill: "url(#paint491_linear_2723_72924)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M195.127 121.484C195.161 121.545 195.145 121.621 195.092 121.66C195.088 121.675 194.932 121.766 194.917 121.775L191.42 123.638L191.36 123.67L187.741 125.597L188.034 125.301L191.275 123.474L191.376 123.418L194.788 121.494C194.8 121.488 194.944 121.412 194.958 121.416C195.019 121.393 195.093 121.421 195.127 121.484Z",
    fill: "url(#paint492_linear_2723_72924)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M195.051 121.524C195.083 121.581 195.065 121.653 195.011 121.687C195.01 121.695 194.849 121.784 194.843 121.787L191.558 123.532L191.505 123.561L188.103 125.369L188.44 125.112L191.46 123.402L191.551 123.35L194.735 121.547C194.742 121.543 194.884 121.466 194.891 121.467C194.949 121.442 195.02 121.465 195.051 121.524Z",
    fill: "url(#paint493_linear_2723_72924)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M188.465 125.139L191.645 123.328L194.825 121.517C194.879 121.488 194.946 121.508 194.976 121.561C195.005 121.615 194.985 121.683 194.931 121.712L191.698 123.426L188.465 125.139Z",
    fill: "url(#paint494_linear_2723_72924)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M190.839 135.081L191.407 136.12L199.141 131.917L206.875 127.714C207.163 127.557 207.269 127.197 207.112 126.91C206.956 126.623 206.597 126.518 206.311 126.673L198.575 130.877L190.839 135.081Z",
    fill: "black"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M207.036 126.948C207.108 127.078 207.121 127.224 207.088 127.356C207.051 127.505 206.947 127.645 206.801 127.725L199.46 131.712L199.286 131.806L191.769 135.89L191.246 134.891L198.481 130.955L198.75 130.809L206.258 126.725C206.39 126.654 206.545 126.637 206.68 126.672C206.826 126.71 206.958 126.804 207.036 126.948Z",
    fill: "url(#paint495_linear_2723_72924)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M206.96 126.987C207.029 127.113 207.04 127.255 207.007 127.382C206.971 127.524 206.866 127.662 206.726 127.737L199.599 131.606L199.431 131.698L192.13 135.661L191.652 134.701L198.665 130.882L198.925 130.741L206.205 126.777C206.331 126.709 206.485 126.69 206.613 126.723C206.756 126.758 206.884 126.848 206.96 126.987Z",
    fill: "url(#paint496_linear_2723_72924)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M206.884 127.027C206.951 127.149 206.959 127.286 206.927 127.409C206.891 127.543 206.784 127.678 206.653 127.75L199.739 131.501L199.578 131.588L192.494 135.432L192.062 134.51L198.853 130.809L199.104 130.673L206.157 126.829C206.276 126.765 206.429 126.743 206.551 126.773C206.685 126.807 206.811 126.893 206.884 127.027Z",
    fill: "url(#paint497_linear_2723_72924)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M206.808 127.064C206.873 127.183 206.878 127.316 206.845 127.434C206.81 127.56 206.702 127.693 206.577 127.76L199.877 131.393L199.722 131.478L192.855 135.202L192.468 134.32L199.038 130.736L199.279 130.604L206.104 126.881C206.216 126.82 206.368 126.797 206.484 126.823C206.614 126.854 206.738 126.935 206.808 127.064Z",
    fill: "url(#paint498_linear_2723_72924)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M206.733 127.103C206.796 127.218 206.798 127.346 206.766 127.459C206.731 127.578 206.62 127.708 206.503 127.772L200.017 131.287L199.868 131.368L193.217 134.972L192.875 134.128L199.223 130.662L199.455 130.535L206.053 126.931C206.158 126.874 206.31 126.848 206.418 126.873C206.545 126.902 206.664 126.978 206.733 127.103Z",
    fill: "url(#paint499_linear_2723_72924)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M206.658 127.143C206.718 127.254 206.718 127.378 206.685 127.486C206.652 127.597 206.539 127.725 206.429 127.785L200.155 131.182L200.013 131.26L193.579 134.744L193.282 133.94L199.408 130.59L199.631 130.469L206.001 126.986C206.1 126.932 206.25 126.903 206.353 126.926C206.474 126.951 206.591 127.022 206.658 127.143Z",
    fill: "url(#paint500_linear_2723_72924)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M206.582 127.181C206.64 127.288 206.637 127.408 206.604 127.512C206.572 127.615 206.457 127.741 206.354 127.796L200.295 131.075L200.159 131.149L193.941 134.513L193.689 133.748L199.593 130.516L199.806 130.4L205.949 127.036C206.041 126.986 206.191 126.955 206.287 126.975C206.404 126.998 206.518 127.064 206.582 127.181Z",
    fill: "url(#paint501_linear_2723_72924)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M206.505 127.22C206.562 127.323 206.556 127.439 206.524 127.538C206.493 127.634 206.376 127.756 206.281 127.808L200.434 130.969L200.304 131.039L194.303 134.284L194.097 133.558L199.779 130.443L199.983 130.331L205.898 127.087C205.983 127.041 206.132 127.007 206.221 127.024C206.334 127.047 206.444 127.108 206.505 127.22Z",
    fill: "url(#paint502_linear_2723_72924)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M206.43 127.259C206.484 127.358 206.476 127.469 206.443 127.564C206.413 127.652 206.294 127.772 206.206 127.82L200.573 130.864L200.45 130.93L194.665 134.056L194.505 133.369L199.965 130.37L200.16 130.264L205.848 127.14C205.927 127.097 206.075 127.061 206.158 127.076C206.263 127.095 206.37 127.152 206.43 127.259Z",
    fill: "url(#paint503_linear_2723_72924)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M206.353 127.298C206.406 127.394 206.394 127.5 206.362 127.591C206.333 127.67 206.211 127.789 206.13 127.832L200.711 130.757L200.594 130.82L195.026 133.825L194.91 133.178L200.149 130.297L200.333 130.195L205.793 127.191C205.865 127.151 206.013 127.113 206.089 127.126C206.193 127.143 206.297 127.195 206.353 127.298Z",
    fill: "url(#paint504_linear_2723_72924)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M206.277 127.336C206.327 127.428 206.314 127.53 206.281 127.615C206.254 127.688 206.13 127.803 206.056 127.843L200.85 130.65L200.739 130.71L195.387 133.596L195.317 132.987L200.334 130.223L200.51 130.126L205.742 127.242C205.808 127.207 205.955 127.165 206.024 127.176C206.123 127.191 206.223 127.237 206.277 127.336Z",
    fill: "url(#paint505_linear_2723_72924)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M206.201 127.376C206.249 127.464 206.233 127.56 206.2 127.642C206.174 127.707 206.047 127.82 205.981 127.856L200.989 130.545L200.884 130.601L195.749 133.367L195.724 132.797L200.518 130.151L200.685 130.06L205.689 127.296C205.749 127.263 205.895 127.219 205.958 127.228C206.053 127.24 206.149 127.282 206.201 127.376Z",
    fill: "url(#paint506_linear_2723_72924)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M206.125 127.413C206.171 127.498 206.152 127.59 206.119 127.667C206.095 127.724 205.965 127.834 205.907 127.866L201.128 130.437L201.03 130.49L196.111 133.136L196.132 132.605L200.705 130.076L200.861 129.989L205.639 127.346C205.692 127.317 205.838 127.286 205.892 127.276C205.982 127.261 206.076 127.324 206.125 127.413Z",
    fill: "url(#paint507_linear_2723_72924)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M206.05 127.452C206.094 127.532 206.086 127.627 206.039 127.693C206.027 127.745 205.884 127.85 205.833 127.878L201.268 130.331L201.176 130.38L196.474 132.906L196.54 132.415L200.891 130.002L201.038 129.921L205.588 127.397C205.634 127.372 205.78 127.337 205.828 127.326C205.911 127.307 206.003 127.367 206.05 127.452Z",
    fill: "url(#paint508_linear_2723_72924)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M205.973 127.492C206.015 127.569 206.006 127.66 205.958 127.72C205.947 127.765 205.802 127.868 205.758 127.891L201.406 130.226L201.32 130.273L196.835 132.679L196.946 132.227L201.074 129.931L201.213 129.855L205.535 127.451C205.574 127.43 205.72 127.368 205.76 127.378C205.843 127.369 205.929 127.412 205.973 127.492Z",
    fill: "url(#paint509_linear_2723_72924)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M205.898 127.531C205.937 127.604 205.927 127.691 205.877 127.746C205.868 127.783 205.72 127.883 205.684 127.902L201.545 130.12L201.466 130.162L197.197 132.449L197.354 132.035L201.261 129.857L201.389 129.785L205.484 127.502C205.516 127.484 205.662 127.419 205.696 127.428C205.772 127.415 205.856 127.454 205.898 127.531Z",
    fill: "url(#paint510_linear_2723_72924)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M205.822 127.572C205.86 127.641 205.847 127.724 205.797 127.774C205.79 127.804 205.639 127.901 205.609 127.917L201.684 130.015L201.611 130.054L197.56 132.221L197.761 131.847L201.446 129.786L201.566 129.719L205.433 127.556C205.459 127.541 205.604 127.473 205.631 127.48C205.702 127.464 205.782 127.499 205.822 127.572Z",
    fill: "url(#paint511_linear_2723_72924)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M205.746 127.609C205.782 127.674 205.768 127.753 205.717 127.798C205.711 127.821 205.557 127.915 205.535 127.926L201.824 129.907L201.757 129.943L197.922 131.99L198.169 131.655L201.632 129.71L201.743 129.649L205.382 127.606C205.401 127.595 205.546 127.524 205.565 127.529C205.632 127.51 205.709 127.542 205.746 127.609Z",
    fill: "url(#paint512_linear_2723_72924)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M205.67 127.647C205.704 127.709 205.688 127.784 205.635 127.824C205.631 127.839 205.475 127.93 205.46 127.938L201.963 129.802L201.903 129.834L198.284 131.761L198.577 131.464L201.818 129.638L201.919 129.581L205.331 127.658C205.343 127.65 205.487 127.576 205.501 127.58C205.562 127.558 205.636 127.585 205.67 127.647Z",
    fill: "url(#paint513_linear_2723_72924)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M205.594 127.685C205.626 127.743 205.607 127.815 205.554 127.849C205.553 127.856 205.392 127.945 205.386 127.949L202.101 129.694L202.047 129.723L198.646 131.53L198.983 131.273L202.003 129.564L202.094 129.512L205.278 127.709C205.285 127.705 205.427 127.628 205.434 127.629C205.491 127.604 205.562 127.628 205.594 127.685Z",
    fill: "url(#paint514_linear_2723_72924)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M199.007 131.303L202.187 129.492L205.367 127.681C205.421 127.652 205.488 127.672 205.517 127.725C205.547 127.779 205.527 127.847 205.473 127.877L202.24 129.589L199.007 131.303Z",
    fill: "url(#paint515_linear_2723_72924)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2723_72924",
    x1: 37.9104,
    y1: 63.1561,
    x2: 16.94,
    y2: 99.6841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0E4FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88B2D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2723_72924",
    x1: 18.5717,
    y1: 54.9218,
    x2: 8.96059,
    y2: 71.5685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2723_72924",
    x1: 12.7467,
    y1: 75.8335,
    x2: 40.0935,
    y2: 75.8335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2723_72924",
    x1: -27.8052,
    y1: 58.5131,
    x2: 65.7762,
    y2: 105.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2723_72924",
    x1: 18.5717,
    y1: 41.217,
    x2: 8.9606,
    y2: 57.8638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2723_72924",
    x1: 15.8169,
    y1: 62.5937,
    x2: 73.3308,
    y2: 50.2461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2723_72924",
    x1: -22.289,
    y1: 47.5951,
    x2: 71.2925,
    y2: 94.8733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2723_72924",
    x1: 18.5717,
    y1: 27.5115,
    x2: 8.96059,
    y2: 44.1582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2723_72924",
    x1: 12.7467,
    y1: 48.4232,
    x2: 36.8628,
    y2: 48.4232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2723_72924",
    x1: -16.7727,
    y1: 36.6764,
    x2: 76.8087,
    y2: 83.9546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2723_72924",
    x1: 16.8976,
    y1: 32.1555,
    x2: 9.82399,
    y2: 44.4073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2723_72924",
    x1: 12.6105,
    y1: 47.5473,
    x2: 30.3597,
    y2: 47.5473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2723_72924",
    x1: -9.11561,
    y1: 38.9018,
    x2: 59.7591,
    y2: 73.6979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2723_72924",
    x1: 18.5717,
    y1: 13.8067,
    x2: 8.96058,
    y2: 30.4535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2723_72924",
    x1: 15.8169,
    y1: 35.1834,
    x2: 73.3308,
    y2: 22.8358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2723_72924",
    x1: -11.2565,
    y1: 25.7585,
    x2: 82.325,
    y2: 73.0367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2723_72924",
    x1: 18.5717,
    y1: 0.0999564,
    x2: 8.96059,
    y2: 16.7467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2723_72924",
    x1: 12.7467,
    y1: 21.011,
    x2: 33.6321,
    y2: 21.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2723_72924",
    x1: -5.74028,
    y1: 14.8379,
    x2: 87.8412,
    y2: 62.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2723_72924",
    x1: 30.5544,
    y1: 61.8553,
    x2: 20.9434,
    y2: 78.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2723_72924",
    x1: 24.7294,
    y1: 82.7689,
    x2: 52.0761,
    y2: 82.7689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2723_72924",
    x1: -28.1593,
    y1: 59.2159,
    x2: 65.4226,
    y2: 106.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2723_72924",
    x1: 30.5544,
    y1: 7.03347,
    x2: 20.9434,
    y2: 23.6802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2723_72924",
    x1: 24.7294,
    y1: 27.9471,
    x2: 45.6146,
    y2: 27.9471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2723_72924",
    x1: -6.09435,
    y1: 15.5414,
    x2: 87.4876,
    y2: 62.8199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2723_72924",
    x1: 28.8802,
    y1: 11.6786,
    x2: 21.8066,
    y2: 23.9304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2723_72924",
    x1: 24.5934,
    y1: 27.0693,
    x2: 39.9646,
    y2: 27.0693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2723_72924",
    x1: 1.90705,
    y1: 17.9389,
    x2: 70.7824,
    y2: 52.7353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2723_72924",
    x1: 42.5682,
    y1: 68.7792,
    x2: 32.9571,
    y2: 85.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2723_72924",
    x1: -12.7224,
    y1: 67.4542,
    x2: 51.8692,
    y2: 100.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2723_72924",
    x1: 42.5682,
    y1: 55.0725,
    x2: 32.9571,
    y2: 71.7192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2723_72924",
    x1: 37.0005,
    y1: 77.0531,
    x2: 94.5142,
    y2: 64.7055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2723_72924",
    x1: -22.9861,
    y1: 48.9752,
    x2: 70.5951,
    y2: 96.2532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2723_72924",
    x1: 42.5682,
    y1: 41.3669,
    x2: 32.9571,
    y2: 58.0137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2723_72924",
    x1: 34.1877,
    y1: 63.9514,
    x2: 91.7013,
    y2: 51.6038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2723_72924",
    x1: -17.4698,
    y1: 38.0566,
    x2: 76.1114,
    y2: 85.3345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2723_72924",
    x1: 42.5682,
    y1: 27.6603,
    x2: 32.9571,
    y2: 44.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2723_72924",
    x1: 31.3749,
    y1: 50.8486,
    x2: 88.8886,
    y2: 38.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2723_72924",
    x1: -11.9536,
    y1: 27.1367,
    x2: 81.6276,
    y2: 74.4146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2723_72924",
    x1: -6.43748,
    y1: 16.2199,
    x2: 87.1437,
    y2: 63.4978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2723_72924",
    x1: 19.059,
    y1: 35.2305,
    x2: 92.6516,
    y2: 19.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2723_72924",
    x1: -6.43748,
    y1: 16.2179,
    x2: 87.1437,
    y2: 63.4959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_2723_72924",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.001 72.3314) scale(9.99208 9.99208)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2723_72924",
    x1: 97.883,
    y1: 95.686,
    x2: 72.8442,
    y2: 139.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0E4FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88B2D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2723_72924",
    x1: 71.5726,
    y1: 86.4827,
    x2: 61.9616,
    y2: 103.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2723_72924",
    x1: 65.7477,
    y1: 107.394,
    x2: 93.0945,
    y2: 107.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2723_72924",
    x1: 25.1958,
    y1: 90.074,
    x2: 118.777,
    y2: 137.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2723_72924",
    x1: 71.5726,
    y1: 72.7772,
    x2: 61.9616,
    y2: 89.4239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2723_72924",
    x1: 68.8179,
    y1: 94.1559,
    x2: 126.332,
    y2: 81.8082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2723_72924",
    x1: 30.712,
    y1: 79.1573,
    x2: 124.293,
    y2: 126.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2723_72924",
    x1: 71.5726,
    y1: 59.0704,
    x2: 61.9616,
    y2: 75.7172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2723_72924",
    x1: 65.7477,
    y1: 79.9822,
    x2: 89.8638,
    y2: 79.9822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2723_72924",
    x1: 36.2283,
    y1: 68.2354,
    x2: 129.81,
    y2: 115.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2723_72924",
    x1: 69.8986,
    y1: 63.7157,
    x2: 62.8251,
    y2: 75.9675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2723_72924",
    x1: 65.6115,
    y1: 79.1062,
    x2: 83.3607,
    y2: 79.1062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2723_72924",
    x1: 43.8853,
    y1: 70.4607,
    x2: 112.76,
    y2: 105.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2723_72924",
    x1: 71.5726,
    y1: 45.3676,
    x2: 61.9616,
    y2: 62.0143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2723_72924",
    x1: 68.8179,
    y1: 66.7455,
    x2: 126.332,
    y2: 54.3979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2723_72924",
    x1: 41.7444,
    y1: 57.3206,
    x2: 135.326,
    y2: 104.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2723_72924",
    x1: 65.7477,
    y1: 52.5719,
    x2: 86.633,
    y2: 52.5719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2723_72924",
    x1: 53.5358,
    y1: 49.9839,
    x2: 118.128,
    y2: 82.6162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2723_72924",
    x1: 83.5554,
    y1: 38.5936,
    x2: 73.9444,
    y2: 55.2403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2723_72924",
    x1: 77.7304,
    y1: 59.5053,
    x2: 98.6156,
    y2: 59.5053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_2723_72924",
    x1: 46.9066,
    y1: 47.0997,
    x2: 140.489,
    y2: 94.3782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_2723_72924",
    x1: 81.8812,
    y1: 43.2375,
    x2: 74.8075,
    y2: 55.4894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_2723_72924",
    x1: 77.5943,
    y1: 58.6294,
    x2: 92.9656,
    y2: 58.6294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_2723_72924",
    x1: 54.908,
    y1: 49.499,
    x2: 123.783,
    y2: 84.2954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_2723_72924",
    x1: 95.5691,
    y1: 100.338,
    x2: 85.9581,
    y2: 116.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_2723_72924",
    x1: 92.8143,
    y1: 121.715,
    x2: 150.328,
    y2: 109.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_2723_72924",
    x1: 24.4985,
    y1: 91.454,
    x2: 118.08,
    y2: 138.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_2723_72924",
    x1: 95.5691,
    y1: 86.6326,
    x2: 85.9581,
    y2: 103.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_2723_72924",
    x1: 90.0015,
    y1: 108.613,
    x2: 147.515,
    y2: 96.2656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_2723_72924",
    x1: 30.0148,
    y1: 80.5353,
    x2: 123.596,
    y2: 127.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_2723_72924",
    x1: 95.5691,
    y1: 72.9279,
    x2: 85.9581,
    y2: 89.5746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_2723_72924",
    x1: 87.1886,
    y1: 95.5123,
    x2: 144.702,
    y2: 83.1647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_2723_72924",
    x1: 35.5311,
    y1: 69.6174,
    x2: 129.112,
    y2: 116.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_2723_72924",
    x1: 95.5691,
    y1: 59.2223,
    x2: 85.9581,
    y2: 75.8691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_2723_72924",
    x1: 84.3759,
    y1: 82.4126,
    x2: 141.89,
    y2: 70.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_2723_72924",
    x1: 41.0473,
    y1: 58.7007,
    x2: 134.629,
    y2: 105.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_2723_72924",
    x1: 72.06,
    y1: 66.7914,
    x2: 145.653,
    y2: 50.9918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_2723_72924",
    x1: 46.5634,
    y1: 47.7788,
    x2: 140.145,
    y2: 95.0568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_2723_72924",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.2433 71.697) scale(23.5522 23.5522)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_2723_72924",
    x1: 148.606,
    y1: 132.218,
    x2: 131.942,
    y2: 161.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0E4FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88B2D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_2723_72924",
    x1: 124.955,
    y1: 63.1019,
    x2: 115.344,
    y2: 79.7488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_2723_72924",
    x1: 119.13,
    y1: 84.0136,
    x2: 140.016,
    y2: 84.0136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_2723_72924",
    x1: 88.3065,
    y1: 71.6081,
    x2: 181.888,
    y2: 118.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_2723_72924",
    x1: 123.281,
    y1: 67.7452,
    x2: 116.207,
    y2: 79.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_2723_72924",
    x1: 118.994,
    y1: 83.1357,
    x2: 134.365,
    y2: 83.1357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_2723_72924",
    x1: 96.3082,
    y1: 74.0054,
    x2: 165.183,
    y2: 108.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_2723_72924",
    x1: 136.908,
    y1: 70.0369,
    x2: 127.297,
    y2: 86.6835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_2723_72924",
    x1: 131.083,
    y1: 90.9486,
    x2: 151.968,
    y2: 90.9486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_2723_72924",
    x1: 112.596,
    y1: 84.7755,
    x2: 206.178,
    y2: 132.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_2723_72924",
    x1: 136.969,
    y1: 124.848,
    x2: 127.358,
    y2: 141.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_2723_72924",
    x1: 134.214,
    y1: 146.224,
    x2: 191.728,
    y2: 133.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_2723_72924",
    x1: 65.8981,
    y1: 115.963,
    x2: 159.48,
    y2: 163.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_2723_72924",
    x1: 136.969,
    y1: 111.143,
    x2: 127.358,
    y2: 127.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_2723_72924",
    x1: 131.401,
    y1: 133.123,
    x2: 188.915,
    y2: 120.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_2723_72924",
    x1: 71.4144,
    y1: 105.045,
    x2: 164.996,
    y2: 152.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_2723_72924",
    x1: 136.969,
    y1: 97.4355,
    x2: 127.358,
    y2: 114.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_2723_72924",
    x1: 128.589,
    y1: 120.02,
    x2: 186.103,
    y2: 107.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_2723_72924",
    x1: 76.9306,
    y1: 94.125,
    x2: 170.512,
    y2: 141.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_2723_72924",
    x1: 135.295,
    y1: 102.136,
    x2: 128.221,
    y2: 114.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_2723_72924",
    x1: 133.267,
    y1: 117.868,
    x2: 175.597,
    y2: 108.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_2723_72924",
    x1: 82.9877,
    y1: 95.5966,
    x2: 151.862,
    y2: 130.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_2723_72924",
    x1: 136.969,
    y1: 83.7307,
    x2: 127.358,
    y2: 100.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_2723_72924",
    x1: 125.776,
    y1: 106.919,
    x2: 183.29,
    y2: 94.5713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_2723_72924",
    x1: 82.447,
    y1: 83.2071,
    x2: 176.028,
    y2: 130.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_2723_72924",
    x1: 136.969,
    y1: 70.0252,
    x2: 127.358,
    y2: 86.6719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_2723_72924",
    x1: 122.963,
    y1: 93.8174,
    x2: 180.477,
    y2: 81.4697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_2723_72924",
    x1: 87.9631,
    y1: 72.2883,
    x2: 181.545,
    y2: 119.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_2723_72924",
    x1: 148.891,
    y1: 76.9711,
    x2: 139.28,
    y2: 93.6179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_2723_72924",
    x1: 143.066,
    y1: 97.8847,
    x2: 163.951,
    y2: 97.8847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_2723_72924",
    x1: 112.242,
    y1: 85.4792,
    x2: 205.824,
    y2: 132.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_2723_72924",
    x1: 190.863,
    y1: 157.478,
    x2: 264.866,
    y2: 157.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_2723_72924",
    x1: 210.564,
    y1: 155.12,
    x2: 218.824,
    y2: 144.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#1E1F21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2388,
    stopColor: "#101012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2677,
    stopColor: "#0E0E0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#131415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4476,
    stopColor: "#232326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5644,
    stopColor: "#3C3D41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6869,
    stopColor: "#5D6066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37383C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_2723_72924",
    x1: 221.617,
    y1: 151.037,
    x2: 212.202,
    y2: 151.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#1E1F21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3101,
    stopColor: "#2C2E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#515359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D6066"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_2723_72924",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(215.94 150.878) rotate(180) scale(5.08588 5.08586)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_2723_72924",
    x1: 214.496,
    y1: 149.929,
    x2: 218.225,
    y2: 151.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_2723_72924",
    x1: 215.546,
    y1: 155.161,
    x2: 219.898,
    y2: 148.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#F7AA90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2316,
    stopColor: "#F9B996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6103,
    stopColor: "#FFE2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6313,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8737,
    stopColor: "#F7AA90"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_2723_72924",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(216.577 151.159) rotate(180) scale(1.82994 1.82993)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_2723_72924",
    x1: 211.741,
    y1: 156.847,
    x2: 216.977,
    y2: 151.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0386,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3465,
    stopColor: "#FFBB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FEE9A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_2723_72924",
    x1: 226.471,
    y1: 129.489,
    x2: 225.722,
    y2: 129.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_2723_72924",
    x1: 226.471,
    y1: 132.065,
    x2: 225.722,
    y2: 132.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_2723_72924",
    x1: 226.302,
    y1: 130.922,
    x2: 225.892,
    y2: 130.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_2723_72924",
    x1: 220.071,
    y1: 128.038,
    x2: 216.948,
    y2: 127.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_2723_72924",
    x1: 226.315,
    y1: 129.166,
    x2: 215.404,
    y2: 126.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_2723_72924",
    x1: 223.567,
    y1: 111.55,
    x2: 224.844,
    y2: 113.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_2723_72924",
    x1: 229.933,
    y1: 149.664,
    x2: 182.08,
    y2: 135.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_2723_72924",
    x1: 273.278,
    y1: 155.463,
    x2: 218.756,
    y2: 143.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_2723_72924",
    x1: 213.145,
    y1: 97.6325,
    x2: 237.396,
    y2: 143.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_2723_72924",
    x1: 249.078,
    y1: 134.426,
    x2: 196.476,
    y2: 118.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_2723_72924",
    x1: 273.31,
    y1: 142.102,
    x2: 244.45,
    y2: 135.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_2723_72924",
    x1: 225.242,
    y1: 83.8025,
    x2: 248.645,
    y2: 128.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_2723_72924",
    x1: 229.789,
    y1: 146.583,
    x2: 183.838,
    y2: 132.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_2723_72924",
    x1: 272.045,
    y1: 152.148,
    x2: 220.044,
    y2: 140.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_2723_72924",
    x1: 213.145,
    y1: 96.3979,
    x2: 237.396,
    y2: 142.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_2723_72924",
    x1: 236.976,
    y1: 120.002,
    x2: 221.02,
    y2: 115.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_2723_72924",
    x1: 247.227,
    y1: 121.954,
    x2: 226.13,
    y2: 117.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_2723_72924",
    x1: 235.146,
    y1: 104.174,
    x2: 236.424,
    y2: 106.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_2723_72924",
    x1: 233.581,
    y1: 127.102,
    x2: 231.499,
    y2: 127.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_2723_72924",
    x1: 236.313,
    y1: 139.508,
    x2: 203.864,
    y2: 129.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_2723_72924",
    x1: 263.148,
    y1: 144.182,
    x2: 229.213,
    y2: 136.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_2723_72924",
    x1: 225.019,
    y1: 103.91,
    x2: 241.234,
    y2: 134.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_2723_72924",
    x1: 232.756,
    y1: 131.658,
    x2: 225.677,
    y2: 131.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_2723_72924",
    x1: 230.958,
    y1: 130.9,
    x2: 216.771,
    y2: 136.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_2723_72924",
    x1: 236.075,
    y1: 126.004,
    x2: 230.162,
    y2: 126.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_2723_72924",
    x1: 220.126,
    y1: 153.251,
    x2: 195.049,
    y2: 145.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_2723_72924",
    x1: 237.349,
    y1: 156.262,
    x2: 215.998,
    y2: 151.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_2723_72924",
    x1: 210.53,
    y1: 127.338,
    x2: 222.328,
    y2: 149.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_2723_72924",
    x1: 225.192,
    y1: 162.767,
    x2: 233.452,
    y2: 151.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#1E1F21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2388,
    stopColor: "#101012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2677,
    stopColor: "#0E0E0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#131415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4476,
    stopColor: "#232326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5644,
    stopColor: "#3C3D41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6869,
    stopColor: "#5D6066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37383C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_2723_72924",
    x1: 236.245,
    y1: 158.683,
    x2: 226.83,
    y2: 158.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#1E1F21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3101,
    stopColor: "#2C2E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#515359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D6066"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint151_radial_2723_72924",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(230.568 158.525) rotate(180) scale(5.08588 5.08585)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_2723_72924",
    x1: 229.124,
    y1: 157.575,
    x2: 232.853,
    y2: 159.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_2723_72924",
    x1: 230.174,
    y1: 162.808,
    x2: 234.526,
    y2: 155.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#F7AA90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2316,
    stopColor: "#F9B996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6103,
    stopColor: "#FFE2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6313,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8737,
    stopColor: "#F7AA90"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint154_radial_2723_72924",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(231.205 158.806) rotate(180) scale(1.82994 1.82993)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_2723_72924",
    x1: 226.369,
    y1: 164.495,
    x2: 231.605,
    y2: 159.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0386,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3465,
    stopColor: "#FFBB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FEE9A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_2723_72924",
    x1: 251.884,
    y1: 155.113,
    x2: 212.776,
    y2: 146.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_2723_72924",
    x1: 236.371,
    y1: 152.83,
    x2: 219.569,
    y2: 147.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_2723_72924",
    x1: 228.443,
    y1: 152.239,
    x2: 224.002,
    y2: 151.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_2723_72924",
    x1: 242.692,
    y1: 143.648,
    x2: 186.435,
    y2: 131.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_2723_72924",
    x1: 254.291,
    y1: 129.757,
    x2: 229.65,
    y2: 124.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_2723_72924",
    x1: 237.397,
    y1: 134.135,
    x2: 222.793,
    y2: 129.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_2723_72924",
    x1: 249.332,
    y1: 135.941,
    x2: 234.799,
    y2: 132.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_2723_72924",
    x1: 231.858,
    y1: 118.562,
    x2: 239.357,
    y2: 132.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_2723_72924",
    x1: 251.304,
    y1: 150.673,
    x2: 259.565,
    y2: 139.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#1E1F21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2388,
    stopColor: "#101012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2677,
    stopColor: "#0E0E0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#131415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4476,
    stopColor: "#232326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5644,
    stopColor: "#3C3D41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6869,
    stopColor: "#5D6066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37383C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_2723_72924",
    x1: 262.358,
    y1: 146.59,
    x2: 252.942,
    y2: 146.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#1E1F21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3101,
    stopColor: "#2C2E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#515359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D6066"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint166_radial_2723_72924",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(256.681 146.431) rotate(180) scale(5.08585 5.08585)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_2723_72924",
    x1: 255.484,
    y1: 145.839,
    x2: 260.146,
    y2: 147.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_2723_72924",
    x1: 256.172,
    y1: 150.891,
    x2: 260.612,
    y2: 143.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#F7AA90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2316,
    stopColor: "#F9B996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6103,
    stopColor: "#FFE2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6313,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8737,
    stopColor: "#F7AA90"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint169_radial_2723_72924",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(257.386 146.812) rotate(180) scale(1.82994 1.82993)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_2723_72924",
    x1: 252.482,
    y1: 152.4,
    x2: 257.718,
    y2: 147.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0386,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3465,
    stopColor: "#FFBB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FEE9A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_2723_72924",
    x1: 253.839,
    y1: 127.487,
    x2: 237.884,
    y2: 122.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_2723_72924",
    x1: 264.089,
    y1: 129.437,
    x2: 242.993,
    y2: 124.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_2723_72924",
    x1: 252.009,
    y1: 111.658,
    x2: 253.286,
    y2: 114.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_2723_72924",
    x1: 235.123,
    y1: 136.696,
    x2: 231.999,
    y2: 135.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_2723_72924",
    x1: 241.366,
    y1: 137.824,
    x2: 230.455,
    y2: 135.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_2723_72924",
    x1: 238.618,
    y1: 120.208,
    x2: 239.895,
    y2: 122.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_2723_72924",
    x1: 242.47,
    y1: 135.64,
    x2: 242.142,
    y2: 135.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2945,
    stopColor: "#7733DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7943,
    stopColor: "#975CED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A56EF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_2723_72924",
    x1: 234.292,
    y1: 118.656,
    x2: 200.194,
    y2: 108.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_2723_72924",
    x1: 266.813,
    y1: 122.761,
    x2: 226.46,
    y2: 113.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_2723_72924",
    x1: 222.452,
    y1: 81.632,
    x2: 240.216,
    y2: 115.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_2723_72924",
    x1: 242.876,
    y1: 134.212,
    x2: 241.734,
    y2: 134.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2945,
    stopColor: "#7733DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7943,
    stopColor: "#975CED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A56EF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_2723_72924",
    x1: 243.102,
    y1: 137.188,
    x2: 241.509,
    y2: 137.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2945,
    stopColor: "#7733DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7943,
    stopColor: "#975CED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A56EF4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint183_radial_2723_72924",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(242.413 116.617) rotate(180) scale(9.78736 9.78737)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint184_radial_2723_72924",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(231.661 150.443) rotate(180) scale(2.3551 2.35509)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_2723_72924",
    x1: 225.39,
    y1: 113.605,
    x2: 208.293,
    y2: 108.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_2723_72924",
    x1: 222.122,
    y1: 114.145,
    x2: 214.128,
    y2: 109.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_2723_72924",
    x1: 216.134,
    y1: 136.668,
    x2: 185.415,
    y2: 127.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_2723_72924",
    x1: 236.021,
    y1: 140.426,
    x2: 195.41,
    y2: 131.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_2723_72924",
    x1: 212.528,
    y1: 106.149,
    x2: 215.158,
    y2: 111.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_2723_72924",
    x1: 217.845,
    y1: 121.245,
    x2: 203.404,
    y2: 116.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_2723_72924",
    x1: 225.595,
    y1: 123.384,
    x2: 218.742,
    y2: 121.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_2723_72924",
    x1: 212.742,
    y1: 107.481,
    x2: 219.552,
    y2: 120.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_2723_72924",
    x1: 217.845,
    y1: 161.567,
    x2: 203.404,
    y2: 157.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_2723_72924",
    x1: 225.595,
    y1: 163.706,
    x2: 218.742,
    y2: 162.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_2723_72924",
    x1: 212.742,
    y1: 147.803,
    x2: 219.552,
    y2: 160.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_2723_72924",
    x1: 223.417,
    y1: 140.881,
    x2: 192.698,
    y2: 131.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_2723_72924",
    x1: 243.304,
    y1: 144.639,
    x2: 202.694,
    y2: 135.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_2723_72924",
    x1: 219.811,
    y1: 110.363,
    x2: 222.441,
    y2: 115.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_2723_72924",
    x1: 213.129,
    y1: 93.4614,
    x2: 224.061,
    y2: 114.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_2723_72924",
    x1: 236.288,
    y1: 119.365,
    x2: 216.491,
    y2: 114.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_2723_72924",
    x1: 224.056,
    y1: 119.948,
    x2: 219.749,
    y2: 114.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint202_radial_2723_72924",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(221.856 125.251) rotate(180) scale(7.44716 7.44717)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint203_radial_2723_72924",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(256.329 131.533) rotate(180) scale(1.94811 1.94809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint204_radial_2723_72924",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(247.543 137.566) rotate(180) scale(5.77651)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint205_radial_2723_72924",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(244.452 128.047) rotate(180) scale(3.45621 3.45623)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_2723_72924",
    x1: 209.457,
    y1: 154.419,
    x2: 212.219,
    y2: 153.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_2723_72924",
    x1: 1309.87,
    y1: -593.679,
    x2: 1352.44,
    y2: -622.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_2723_72924",
    x1: 206.03,
    y1: 147.899,
    x2: 204.402,
    y2: 151.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_2723_72924",
    x1: 213.219,
    y1: 152.304,
    x2: 215.981,
    y2: 151.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_2723_72924",
    x1: 1313.65,
    y1: -595.8,
    x2: 1356.21,
    y2: -624.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_2723_72924",
    x1: 209.792,
    y1: 145.784,
    x2: 208.164,
    y2: 148.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_2723_72924",
    x1: 216.939,
    y1: 150.107,
    x2: 219.702,
    y2: 149.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_2723_72924",
    x1: 1317.36,
    y1: -597.992,
    x2: 1359.93,
    y2: -626.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_2723_72924",
    x1: 213.513,
    y1: 143.586,
    x2: 211.885,
    y2: 146.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_2723_72924",
    x1: 206.23,
    y1: 157.136,
    x2: 163.664,
    y2: 128.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_2723_72924",
    x1: 198.255,
    y1: 149.86,
    x2: 192.76,
    y2: 148.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_2723_72924",
    x1: 193.985,
    y1: 144.99,
    x2: 195.132,
    y2: 147.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_2723_72924",
    x1: 205.652,
    y1: 156.616,
    x2: 208.414,
    y2: 155.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_2723_72924",
    x1: 1306.08,
    y1: -591.487,
    x2: 1348.65,
    y2: -620.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_2723_72924",
    x1: 202.225,
    y1: 150.096,
    x2: 200.598,
    y2: 153.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_2723_72924",
    x1: 212.196,
    y1: 140.378,
    x2: 193.286,
    y2: 140.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_2723_72924",
    x1: 202.632,
    y1: 147.266,
    x2: 206.295,
    y2: 133.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_2723_72924",
    x1: 217.845,
    y1: 142.085,
    x2: 203.404,
    y2: 137.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_2723_72924",
    x1: 225.595,
    y1: 144.224,
    x2: 218.742,
    y2: 142.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_2723_72924",
    x1: 212.742,
    y1: 128.32,
    x2: 219.552,
    y2: 141.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_2723_72924",
    x1: 223.478,
    y1: 138.869,
    x2: 221.907,
    y2: 138.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_2723_72924",
    x1: 217.903,
    y1: 118.28,
    x2: 216.038,
    y2: 130.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_2723_72924",
    x1: 221.095,
    y1: 132.228,
    x2: 200.982,
    y2: 145.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_2723_72924",
    x1: 210.871,
    y1: 128.358,
    x2: 207.229,
    y2: 127.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_2723_72924",
    x1: 220.961,
    y1: 145.438,
    x2: 202.05,
    y2: 145.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_2723_72924",
    x1: 209.73,
    y1: 155.165,
    x2: 219.787,
    y2: 136.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_2723_72924",
    x1: 209.954,
    y1: 153.735,
    x2: 205.772,
    y2: 152.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_2723_72924",
    x1: 213.352,
    y1: 154.244,
    x2: 207.857,
    y2: 153.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_2723_72924",
    x1: 209.082,
    y1: 149.373,
    x2: 210.229,
    y2: 151.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_2723_72924",
    x1: 213.722,
    y1: 151.56,
    x2: 209.54,
    y2: 150.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_2723_72924",
    x1: 217.12,
    y1: 152.07,
    x2: 211.625,
    y2: 150.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_2723_72924",
    x1: 212.85,
    y1: 147.199,
    x2: 213.997,
    y2: 149.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_2723_72924",
    x1: 217.491,
    y1: 149.387,
    x2: 213.309,
    y2: 148.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_2723_72924",
    x1: 220.889,
    y1: 149.894,
    x2: 215.394,
    y2: 148.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_2723_72924",
    x1: 216.619,
    y1: 145.024,
    x2: 217.766,
    y2: 147.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_2723_72924",
    x1: 207.098,
    y1: 153.942,
    x2: 204.335,
    y2: 153.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_2723_72924",
    x1: 226.636,
    y1: 154.353,
    x2: 197.847,
    y2: 147.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_2723_72924",
    x1: 210.524,
    y1: 147.422,
    x2: 212.152,
    y2: 150.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_2723_72924",
    x1: 205.652,
    y1: 153.983,
    x2: 208.414,
    y2: 153.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_2723_72924",
    x1: 1304.86,
    y1: -593.298,
    x2: 1347.43,
    y2: -621.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_2723_72924",
    x1: 202.225,
    y1: 147.463,
    x2: 200.598,
    y2: 150.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_2723_72924",
    x1: 206.729,
    y1: 156.394,
    x2: 164.162,
    y2: 127.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_2723_72924",
    x1: 209.583,
    y1: 156.416,
    x2: 204.088,
    y2: 155.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_2723_72924",
    x1: 205.313,
    y1: 151.546,
    x2: 206.46,
    y2: 153.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_2723_72924",
    x1: 193.587,
    y1: 122.662,
    x2: 207.347,
    y2: 148.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_2723_72924",
    x1: 212.857,
    y1: 122.735,
    x2: 203.246,
    y2: 139.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_2723_72924",
    x1: 207.032,
    y1: 143.646,
    x2: 231.148,
    y2: 143.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_2723_72924",
    x1: 165.175,
    y1: 125.666,
    x2: 258.757,
    y2: 172.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_2723_72924",
    x1: 210.282,
    y1: 138.307,
    x2: 185.206,
    y2: 152.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0711,
    stopColor: "#BD3492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1974,
    stopColor: "#8B276B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3269,
    stopColor: "#601B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#3E1130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5887,
    stopColor: "#230A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7218,
    stopColor: "#0F040C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8575,
    stopColor: "#040103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_2723_72924",
    x1: 209.233,
    y1: 138.923,
    x2: 190.736,
    y2: 149.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0152,
    stopColor: "#29EEF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#1FB7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#17868B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3727,
    stopColor: "#105D60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4942,
    stopColor: "#0A3B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6167,
    stopColor: "#062123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    stopColor: "#030F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8672,
    stopColor: "#010404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_2723_72924",
    x1: 211.139,
    y1: 127.458,
    x2: 204.065,
    y2: 139.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_2723_72924",
    x1: 209.111,
    y1: 143.19,
    x2: 251.441,
    y2: 134.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_2723_72924",
    x1: 158.832,
    y1: 120.919,
    x2: 227.706,
    y2: 155.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_2723_72924",
    x1: 44.1845,
    y1: 128.122,
    x2: 21.43,
    y2: 168.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0E4FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88B2D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_2723_72924",
    x1: 31.3942,
    y1: 112.832,
    x2: 5.8125,
    y2: 105.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_2723_72924",
    x1: 49.7525,
    y1: 116.551,
    x2: 10.5506,
    y2: 107.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_2723_72924",
    x1: 25.4324,
    y1: 99.0518,
    x2: 26.6902,
    y2: 101.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_2723_72924",
    x1: 46.9992,
    y1: 109.6,
    x2: 17.5904,
    y2: 100.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_2723_72924",
    x1: 55.9259,
    y1: 113.053,
    x2: 49.4595,
    y2: 111.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_2723_72924",
    x1: 32.0421,
    y1: 81.543,
    x2: 46.8345,
    y2: 109.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_2723_72924",
    x1: 60.7423,
    y1: 109.218,
    x2: 63.5046,
    y2: 108.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_2723_72924",
    x1: 1161.16,
    y1: -638.879,
    x2: 1203.73,
    y2: -667.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_2723_72924",
    x1: 57.316,
    y1: 102.698,
    x2: 55.6879,
    y2: 105.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_2723_72924",
    x1: 64.5054,
    y1: 107.103,
    x2: 67.2679,
    y2: 106.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_2723_72924",
    x1: 1164.92,
    y1: -640.991,
    x2: 1207.49,
    y2: -669.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_2723_72924",
    x1: 61.0792,
    y1: 100.583,
    x2: 59.4511,
    y2: 103.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint272_linear_2723_72924",
    x1: 68.2249,
    y1: 104.904,
    x2: 70.9875,
    y2: 104.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_2723_72924",
    x1: 1168.65,
    y1: -643.193,
    x2: 1211.21,
    y2: -671.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_2723_72924",
    x1: 64.7985,
    y1: 98.3834,
    x2: 63.1705,
    y2: 101.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_2723_72924",
    x1: 61.2399,
    y1: 108.531,
    x2: 57.0579,
    y2: 107.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_2723_72924",
    x1: 64.6373,
    y1: 109.041,
    x2: 59.1419,
    y2: 107.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_2723_72924",
    x1: 60.3679,
    y1: 104.17,
    x2: 61.5148,
    y2: 106.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_2723_72924",
    x1: 65.008,
    y1: 106.359,
    x2: 60.8264,
    y2: 105.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_2723_72924",
    x1: 68.4062,
    y1: 106.867,
    x2: 62.9109,
    y2: 105.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint280_linear_2723_72924",
    x1: 64.1361,
    y1: 101.997,
    x2: 65.283,
    y2: 104.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint281_linear_2723_72924",
    x1: 68.7769,
    y1: 104.186,
    x2: 64.595,
    y2: 102.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint282_linear_2723_72924",
    x1: 72.1752,
    y1: 104.693,
    x2: 66.6798,
    y2: 103.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint283_linear_2723_72924",
    x1: 67.905,
    y1: 99.8235,
    x2: 69.0518,
    y2: 102.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint284_linear_2723_72924",
    x1: 57.5159,
    y1: 111.933,
    x2: 14.9498,
    y2: 83.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint285_linear_2723_72924",
    x1: 49.5409,
    y1: 104.658,
    x2: 44.0455,
    y2: 103.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint286_linear_2723_72924",
    x1: 45.2711,
    y1: 99.7868,
    x2: 46.4176,
    y2: 101.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint287_linear_2723_72924",
    x1: 56.9376,
    y1: 111.413,
    x2: 59.6999,
    y2: 110.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint288_linear_2723_72924",
    x1: 1157.37,
    y1: -636.69,
    x2: 1199.93,
    y2: -665.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint289_linear_2723_72924",
    x1: 53.5112,
    y1: 104.893,
    x2: 51.8831,
    y2: 107.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint290_linear_2723_72924",
    x1: 48.8036,
    y1: 112.946,
    x2: 67.0825,
    y2: 101.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint291_linear_2723_72924",
    x1: 59.0453,
    y1: 107.848,
    x2: 53.3606,
    y2: 95.5161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint292_linear_2723_72924",
    x1: 40.6212,
    y1: 107.163,
    x2: 59.1625,
    y2: 97.0181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint293_linear_2723_72924",
    x1: 55.7126,
    y1: 102.446,
    x2: 36.128,
    y2: 102.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint294_linear_2723_72924",
    x1: 58.3837,
    y1: 108.739,
    x2: 55.6213,
    y2: 107.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint295_linear_2723_72924",
    x1: 77.9219,
    y1: 109.15,
    x2: 49.1326,
    y2: 102.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint296_linear_2723_72924",
    x1: 61.8101,
    y1: 102.219,
    x2: 63.4382,
    y2: 105.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint297_linear_2723_72924",
    x1: 56.9376,
    y1: 108.78,
    x2: 59.6999,
    y2: 107.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint298_linear_2723_72924",
    x1: 1156.15,
    y1: -638.501,
    x2: 1198.71,
    y2: -667.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint299_linear_2723_72924",
    x1: 53.5112,
    y1: 102.26,
    x2: 51.8831,
    y2: 105.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint300_linear_2723_72924",
    x1: 58.0145,
    y1: 111.191,
    x2: 15.448,
    y2: 82.5013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint301_linear_2723_72924",
    x1: 60.8692,
    y1: 111.214,
    x2: 55.3737,
    y2: 109.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint302_linear_2723_72924",
    x1: 56.599,
    y1: 106.343,
    x2: 57.7458,
    y2: 108.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint303_linear_2723_72924",
    x1: 44.8724,
    y1: 77.4589,
    x2: 58.6333,
    y2: 103.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint304_linear_2723_72924",
    x1: 64.1415,
    y1: 77.5329,
    x2: 54.5305,
    y2: 94.1797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint305_linear_2723_72924",
    x1: 57.9259,
    y1: 94.9849,
    x2: 81.0055,
    y2: 81.8949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43E8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0944,
    stopColor: "#36BDB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2176,
    stopColor: "#288B87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3438,
    stopColor: "#1C605D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4708,
    stopColor: "#123E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.599,
    stopColor: "#0A2321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7287,
    stopColor: "#040F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8611,
    stopColor: "#010404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint306_linear_2723_72924",
    x1: 61.2536,
    y1: 93.1804,
    x2: 78.4554,
    y2: 83.4241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0711,
    stopColor: "#BD3492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1974,
    stopColor: "#8B276B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3269,
    stopColor: "#601B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#3E1130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5887,
    stopColor: "#230A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7218,
    stopColor: "#0F040C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8575,
    stopColor: "#040103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint307_linear_2723_72924",
    x1: 58.3164,
    y1: 98.4446,
    x2: 82.4324,
    y2: 98.4446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint308_linear_2723_72924",
    x1: 16.4603,
    y1: 80.4654,
    x2: 110.042,
    y2: 127.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint309_linear_2723_72924",
    x1: 62.4875,
    y1: 82.1257,
    x2: 55.4138,
    y2: 94.3775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint310_linear_2723_72924",
    x1: 60.4602,
    y1: 97.8585,
    x2: 102.79,
    y2: 88.7708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint311_linear_2723_72924",
    x1: 10.1801,
    y1: 75.5869,
    x2: 79.055,
    y2: 110.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint312_linear_2723_72924",
    x1: 58.6848,
    y1: 104.336,
    x2: 43.8097,
    y2: 101.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint313_linear_2723_72924",
    x1: 52.1779,
    y1: 91.5108,
    x2: 38.3238,
    y2: 91.5108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint314_linear_2723_72924",
    x1: 50.6318,
    y1: 99.6024,
    x2: 38.3238,
    y2: 99.6024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint315_linear_2723_72924",
    x1: 41.5488,
    y1: 109.668,
    x2: 9.59698,
    y2: 100.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint316_linear_2723_72924",
    x1: 62.1053,
    y1: 113.576,
    x2: 19.8601,
    y2: 104.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint317_linear_2723_72924",
    x1: 37.8681,
    y1: 77.9646,
    x2: 40.4587,
    y2: 82.9017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint318_linear_2723_72924",
    x1: 18.9785,
    y1: 125.597,
    x2: 18.2413,
    y2: 125.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint319_linear_2723_72924",
    x1: 20.7354,
    y1: 144.911,
    x2: -19.2257,
    y2: 132.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint320_linear_2723_72924",
    x1: 62.2348,
    y1: 149.781,
    x2: 8.53812,
    y2: 137.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint321_linear_2723_72924",
    x1: 8.17187,
    y1: 100.361,
    x2: 28.3705,
    y2: 138.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint322_linear_2723_72924",
    x1: 20.5929,
    y1: 141.874,
    x2: -17.4948,
    y2: 130.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint323_linear_2723_72924",
    x1: 61.0201,
    y1: 146.516,
    x2: 9.80667,
    y2: 135.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint324_linear_2723_72924",
    x1: 8.17186,
    y1: 99.1445,
    x2: 28.3705,
    y2: 137.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint325_linear_2723_72924",
    x1: 14.063,
    y1: 122.526,
    x2: -1.65131,
    y2: 117.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint326_linear_2723_72924",
    x1: 24.1586,
    y1: 124.449,
    x2: 3.38087,
    y2: 119.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint327_linear_2723_72924",
    x1: 12.2609,
    y1: 106.939,
    x2: 13.5183,
    y2: 109.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint328_linear_2723_72924",
    x1: 21.3984,
    y1: 137.307,
    x2: -11.5141,
    y2: 127.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint329_linear_2723_72924",
    x1: 50.1797,
    y1: 142.435,
    x2: 13.2362,
    y2: 134.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint330_linear_2723_72924",
    x1: 12.5545,
    y1: 110.359,
    x2: 28.5237,
    y2: 140.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint331_linear_2723_72924",
    x1: 40.2251,
    y1: 128.771,
    x2: 2.76774,
    y2: 117.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint332_linear_2723_72924",
    x1: 57.0365,
    y1: 133.629,
    x2: 32.0176,
    y2: 128.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint333_linear_2723_72924",
    x1: 21.0556,
    y1: 95.4716,
    x2: 36.6364,
    y2: 125.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint334_linear_2723_72924",
    x1: 30.0483,
    y1: 123.358,
    x2: 34.0276,
    y2: 120.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint335_linear_2723_72924",
    x1: 32.375,
    y1: 122.779,
    x2: 25.2471,
    y2: 119.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint336_linear_2723_72924",
    x1: 34.0059,
    y1: 118.843,
    x2: 27.7728,
    y2: 117.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint337_linear_2723_72924",
    x1: 22.0939,
    y1: 130.347,
    x2: 6.83919,
    y2: 125.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint338_linear_2723_72924",
    x1: 34.5599,
    y1: 132.234,
    x2: 19.3798,
    y2: 128.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint339_linear_2723_72924",
    x1: 16.3076,
    y1: 114.083,
    x2: 24.1401,
    y2: 129.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint340_linear_2723_72924",
    x1: 36.7189,
    y1: 130.381,
    x2: 2.83057,
    y2: 122.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint341_linear_2723_72924",
    x1: 28.9658,
    y1: 130.881,
    x2: 13.2519,
    y2: 126.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint342_linear_2723_72924",
    x1: 39.0622,
    y1: 132.806,
    x2: 18.2844,
    y2: 128.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint343_linear_2723_72924",
    x1: 27.1637,
    y1: 115.295,
    x2: 28.4211,
    y2: 117.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint344_linear_2723_72924",
    x1: 43.6734,
    y1: 87.0179,
    x2: 29.4506,
    y2: 82.7592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint345_linear_2723_72924",
    x1: 51.3064,
    y1: 89.1242,
    x2: 44.5561,
    y2: 87.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint346_linear_2723_72924",
    x1: 38.6468,
    y1: 73.4613,
    x2: 45.354,
    y2: 86.2443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint347_linear_2723_72924",
    x1: 48.7216,
    y1: 113.606,
    x2: 16.7701,
    y2: 104.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint348_linear_2723_72924",
    x1: 69.2785,
    y1: 117.515,
    x2: 27.0329,
    y2: 108.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint349_linear_2723_72924",
    x1: 45.041,
    y1: 81.9023,
    x2: 47.6315,
    y2: 86.8394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint350_linear_2723_72924",
    x1: 31.5119,
    y1: 130.356,
    x2: 31.8356,
    y2: 130.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint351_linear_2723_72924",
    x1: 31.1115,
    y1: 128.949,
    x2: 32.2362,
    y2: 128.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint352_linear_2723_72924",
    x1: 30.8895,
    y1: 131.882,
    x2: 32.4586,
    y2: 131.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint353_linear_2723_72924",
    x1: 43.4364,
    y1: 143.923,
    x2: 51.5716,
    y2: 133.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#1E1F21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2388,
    stopColor: "#101012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2677,
    stopColor: "#0E0E0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#131415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4476,
    stopColor: "#232326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5644,
    stopColor: "#3C3D41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6869,
    stopColor: "#5D6066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37383C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint354_linear_2723_72924",
    x1: 54.3217,
    y1: 139.9,
    x2: 45.0491,
    y2: 139.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#1E1F21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3101,
    stopColor: "#2C2E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#515359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D6066"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint355_radial_2723_72924",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.7311 139.743) rotate(180) scale(5.00888 5.00889)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint356_linear_2723_72924",
    x1: 47.5518,
    y1: 139.159,
    x2: 52.1434,
    y2: 141.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint357_linear_2723_72924",
    x1: 48.2293,
    y1: 144.138,
    x2: 52.6023,
    y2: 137.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#F7AA90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2316,
    stopColor: "#F9B996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6103,
    stopColor: "#FFE2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6313,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8737,
    stopColor: "#F7AA90"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint358_radial_2723_72924",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.4902 140.153) rotate(180) scale(1.80229 1.80227)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint359_linear_2723_72924",
    x1: 44.5956,
    y1: 145.625,
    x2: 49.7527,
    y2: 140.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0386,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3465,
    stopColor: "#FFBB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FEE9A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint360_linear_2723_72924",
    x1: 68.2329,
    y1: 137.538,
    x2: 29.7162,
    y2: 128.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint361_linear_2723_72924",
    x1: 52.9547,
    y1: 135.291,
    x2: 36.4066,
    y2: 130.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint362_linear_2723_72924",
    x1: 45.1464,
    y1: 134.709,
    x2: 40.7734,
    y2: 133.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint363_linear_2723_72924",
    x1: 25.0449,
    y1: 146.891,
    x2: -14.6969,
    y2: 134.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint364_linear_2723_72924",
    x1: 14.401,
    y1: 149.2,
    x2: -25.3412,
    y2: 137.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint365_linear_2723_72924",
    x1: 21.4663,
    y1: 151.858,
    x2: -5.11424,
    y2: 143.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint366_linear_2723_72924",
    x1: 36.0549,
    y1: 150.196,
    x2: 12.0698,
    y2: 144.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint367_linear_2723_72924",
    x1: -1.06809,
    y1: 100.292,
    x2: 17.7162,
    y2: 136.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint368_linear_2723_72924",
    x1: 20.7186,
    y1: 156.466,
    x2: 28.8542,
    y2: 145.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#1E1F21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2388,
    stopColor: "#101012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2677,
    stopColor: "#0E0E0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#131415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4476,
    stopColor: "#232326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5644,
    stopColor: "#3C3D41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6869,
    stopColor: "#5D6066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37383C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint369_linear_2723_72924",
    x1: 31.6045,
    y1: 152.443,
    x2: 22.332,
    y2: 152.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#1E1F21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3101,
    stopColor: "#2C2E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#515359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D6066"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint370_radial_2723_72924",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.0137 152.287) rotate(180) scale(5.00889 5.00888)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint371_linear_2723_72924",
    x1: 24.5906,
    y1: 151.355,
    x2: 28.2638,
    y2: 153.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3169,
    stopColor: "#FFB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#FEE1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint372_linear_2723_72924",
    x1: 25.6255,
    y1: 156.506,
    x2: 29.9109,
    y2: 149.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#F7AA90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2316,
    stopColor: "#F9B996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6103,
    stopColor: "#FFE2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6313,
    stopColor: "#FFE4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8737,
    stopColor: "#F7AA90"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint373_radial_2723_72924",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.7403 152.729) rotate(180) scale(1.80229 1.80227)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint374_linear_2723_72924",
    x1: 21.8782,
    y1: 158.167,
    x2: 27.0352,
    y2: 152.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0386,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3465,
    stopColor: "#FFBB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FEE9A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint375_linear_2723_72924",
    x1: 46.1746,
    y1: 121.928,
    x2: 20.5929,
    y2: 114.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint376_linear_2723_72924",
    x1: 64.5321,
    y1: 125.647,
    x2: 25.3303,
    y2: 116.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint377_linear_2723_72924",
    x1: 40.2128,
    y1: 108.148,
    x2: 41.4706,
    y2: 110.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint378_linear_2723_72924",
    x1: 22.7448,
    y1: 114.489,
    x2: -10.8372,
    y2: 104.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint379_linear_2723_72924",
    x1: 54.7738,
    y1: 118.532,
    x2: 15.0313,
    y2: 109.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint380_linear_2723_72924",
    x1: 11.0839,
    y1: 78.0261,
    x2: 28.5785,
    y2: 111.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint381_linear_2723_72924",
    x1: 38.8065,
    y1: 123.52,
    x2: 35.3629,
    y2: 129.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint382_linear_2723_72924",
    x1: 37.6202,
    y1: 125.925,
    x2: 34.1099,
    y2: 124.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint383_linear_2723_72924",
    x1: 37.1211,
    y1: 125.337,
    x2: 37.4446,
    y2: 125.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint384_linear_2723_72924",
    x1: 36.9521,
    y1: 126.933,
    x2: 37.6146,
    y2: 126.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint385_linear_2723_72924",
    x1: 36.7206,
    y1: 123.931,
    x2: 37.8452,
    y2: 123.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint386_radial_2723_72924",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.9197 134.527) rotate(180) scale(8.93038 8.93038)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint387_radial_2723_72924",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.849 111.171) rotate(180) scale(9.63927 9.63926)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint388_radial_2723_72924",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.361 132.886) rotate(180) scale(2.31945 2.31945)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint389_radial_2723_72924",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.2074 128.462) rotate(180) scale(3.36724 3.36724)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint390_radial_2723_72924",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.0556 97.444) rotate(180) scale(8.02171 8.02172)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint391_linear_2723_72924",
    x1: 199.327,
    y1: 154.465,
    x2: 174.289,
    y2: 197.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0E4FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88B2D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint392_linear_2723_72924",
    x1: 173.017,
    y1: 145.26,
    x2: 163.406,
    y2: 161.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint393_linear_2723_72924",
    x1: 167.192,
    y1: 166.173,
    x2: 194.539,
    y2: 166.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint394_linear_2723_72924",
    x1: 126.64,
    y1: 148.853,
    x2: 220.221,
    y2: 196.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint395_linear_2723_72924",
    x1: 173.017,
    y1: 131.555,
    x2: 163.406,
    y2: 148.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint396_linear_2723_72924",
    x1: 170.262,
    y1: 152.931,
    x2: 227.776,
    y2: 140.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint397_linear_2723_72924",
    x1: 132.156,
    y1: 137.933,
    x2: 225.738,
    y2: 185.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint398_linear_2723_72924",
    x1: 173.017,
    y1: 117.849,
    x2: 163.406,
    y2: 134.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint399_linear_2723_72924",
    x1: 167.192,
    y1: 138.761,
    x2: 191.308,
    y2: 138.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint400_linear_2723_72924",
    x1: 137.673,
    y1: 127.014,
    x2: 231.254,
    y2: 174.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint401_linear_2723_72924",
    x1: 171.343,
    y1: 122.495,
    x2: 164.269,
    y2: 134.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint402_linear_2723_72924",
    x1: 167.056,
    y1: 137.886,
    x2: 184.805,
    y2: 137.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint403_linear_2723_72924",
    x1: 145.33,
    y1: 129.24,
    x2: 214.205,
    y2: 164.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint404_linear_2723_72924",
    x1: 173.017,
    y1: 104.144,
    x2: 163.406,
    y2: 120.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint405_linear_2723_72924",
    x1: 170.262,
    y1: 125.521,
    x2: 227.776,
    y2: 113.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint406_linear_2723_72924",
    x1: 143.189,
    y1: 116.096,
    x2: 236.77,
    y2: 163.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint407_linear_2723_72924",
    x1: 167.192,
    y1: 111.351,
    x2: 188.077,
    y2: 111.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint408_linear_2723_72924",
    x1: 154.98,
    y1: 108.763,
    x2: 219.572,
    y2: 141.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint409_linear_2723_72924",
    x1: 185,
    y1: 124.783,
    x2: 175.389,
    y2: 141.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint410_linear_2723_72924",
    x1: 179.175,
    y1: 145.695,
    x2: 203.291,
    y2: 145.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint411_linear_2723_72924",
    x1: 137.318,
    y1: 127.716,
    x2: 230.9,
    y2: 174.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint412_linear_2723_72924",
    x1: 197.013,
    y1: 159.117,
    x2: 187.402,
    y2: 175.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint413_linear_2723_72924",
    x1: 194.259,
    y1: 180.494,
    x2: 251.772,
    y2: 168.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint414_linear_2723_72924",
    x1: 125.943,
    y1: 150.233,
    x2: 219.524,
    y2: 197.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint415_linear_2723_72924",
    x1: 195.339,
    y1: 163.761,
    x2: 188.266,
    y2: 176.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint416_linear_2723_72924",
    x1: 193.312,
    y1: 179.495,
    x2: 235.642,
    y2: 170.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint417_linear_2723_72924",
    x1: 143.032,
    y1: 157.223,
    x2: 211.907,
    y2: 192.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint418_linear_2723_72924",
    x1: 197.013,
    y1: 145.41,
    x2: 187.402,
    y2: 162.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint419_linear_2723_72924",
    x1: 191.446,
    y1: 167.391,
    x2: 248.959,
    y2: 155.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint420_linear_2723_72924",
    x1: 131.459,
    y1: 139.313,
    x2: 225.04,
    y2: 186.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint421_radial_2723_72924",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(173.446 135.214) scale(9.992 9.992)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint422_linear_2723_72924",
    x1: 197.013,
    y1: 118.063,
    x2: 187.402,
    y2: 134.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint423_linear_2723_72924",
    x1: 185.82,
    y1: 141.251,
    x2: 243.334,
    y2: 128.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint424_linear_2723_72924",
    x1: 142.492,
    y1: 117.539,
    x2: 236.073,
    y2: 164.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint425_linear_2723_72924",
    x1: 173.504,
    y1: 125.633,
    x2: 247.097,
    y2: 109.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint426_linear_2723_72924",
    x1: 148.008,
    y1: 106.62,
    x2: 241.589,
    y2: 153.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint427_linear_2723_72924",
    x1: 184.971,
    y1: 74.1952,
    x2: 175.36,
    y2: 90.8419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint428_linear_2723_72924",
    x1: 179.146,
    y1: 95.1068,
    x2: 200.032,
    y2: 95.1068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint429_linear_2723_72924",
    x1: 148.323,
    y1: 82.7013,
    x2: 241.904,
    y2: 129.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    stopColor: "#6E41D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint430_linear_2723_72924",
    x1: 183.297,
    y1: 78.8404,
    x2: 176.223,
    y2: 91.0922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint431_linear_2723_72924",
    x1: 179.01,
    y1: 94.231,
    x2: 194.381,
    y2: 94.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint432_linear_2723_72924",
    x1: 156.324,
    y1: 85.1006,
    x2: 225.199,
    y2: 119.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint433_linear_2723_72924",
    x1: 157.207,
    y1: 19.4559,
    x2: 170.104,
    y2: 11.4436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2257,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5946,
    stopColor: "#1FC3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint434_linear_2723_72924",
    x1: 162.241,
    y1: 12.994,
    x2: 150.744,
    y2: 26.1575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2257,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5946,
    stopColor: "#1FC3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint435_linear_2723_72924",
    x1: 154.06,
    y1: 25.4279,
    x2: 147.006,
    y2: 17.9479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2257,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5946,
    stopColor: "#1FC3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint436_linear_2723_72924",
    x1: 144.377,
    y1: 19.0988,
    x2: 157.439,
    y2: 26.3934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2257,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5946,
    stopColor: "#1FC3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint437_radial_2723_72924",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199.859 38.7268) scale(38.0889)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6414,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7563,
    stopColor: "#CFB1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8391,
    stopColor: "#C7A8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9119,
    stopColor: "#B998D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9785,
    stopColor: "#A782CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F79C8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint438_radial_2723_72924",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(187.724 37.4751) scale(22.1802 22.1802)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6414,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7563,
    stopColor: "#CFB1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8391,
    stopColor: "#C7A8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9119,
    stopColor: "#B998D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9785,
    stopColor: "#A782CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F79C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint439_linear_2723_72924",
    x1: 189.686,
    y1: 57.7336,
    x2: 206.589,
    y2: 57.7336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint440_linear_2723_72924",
    x1: 133.732,
    y1: -18.0653,
    x2: 164.021,
    y2: 37.6546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2257,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5946,
    stopColor: "#1FC3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint441_linear_2723_72924",
    x1: 190.332,
    y1: 64.271,
    x2: 179.516,
    y2: 43.7937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint442_radial_2723_72924",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(168.018 36.1721) scale(37.8158 37.8158)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#138BBD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint443_radial_2723_72924",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(173.14 29.6481) scale(23.208 23.208)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#138BBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint444_linear_2723_72924",
    x1: 183.301,
    y1: 26.6133,
    x2: 176.287,
    y2: 40.9502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1948,
    stopColor: "#979899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3972,
    stopColor: "#616263"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5861,
    stopColor: "#373838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7554,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8991,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint445_linear_2723_72924",
    x1: 144.279,
    y1: 30.8369,
    x2: 143.198,
    y2: 21.6438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2257,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5946,
    stopColor: "#1FC3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint446_linear_2723_72924",
    x1: 145.091,
    y1: 18.7734,
    x2: 143.577,
    y2: 33.3744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2257,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5946,
    stopColor: "#1FC3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint447_linear_2723_72924",
    x1: 179.565,
    y1: 37.9261,
    x2: 182.896,
    y2: 37.9261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0488,
    stopColor: "#C8ABDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1149,
    stopColor: "#DAC6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1998,
    stopColor: "#F7F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2222,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2513,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3001,
    stopColor: "#E9DBF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3586,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4264,
    stopColor: "#B395D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4949,
    stopColor: "#9C7DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5583,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6111,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    stopColor: "#9471C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint448_linear_2723_72924",
    x1: 183.8,
    y1: 34.5783,
    x2: 178.088,
    y2: 34.5783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#1BB0D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#1EBFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5265,
    stopColor: "#27E8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6313,
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8737,
    stopColor: "#1BB0D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint449_linear_2723_72924",
    x1: 184.254,
    y1: 30.0664,
    x2: 180.19,
    y2: 34.4245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2257,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5946,
    stopColor: "#1FC3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint450_linear_2723_72924",
    x1: 139.83,
    y1: 28.9736,
    x2: 152.727,
    y2: 20.9613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2257,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5946,
    stopColor: "#1FC3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint451_linear_2723_72924",
    x1: 144.864,
    y1: 22.5117,
    x2: 133.367,
    y2: 35.6753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2257,
    stopColor: "#169AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5946,
    stopColor: "#1FC3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint452_linear_2723_72924",
    x1: 201.345,
    y1: 51.2384,
    x2: 197.231,
    y2: 57.1883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0133,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2616,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4929,
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7003,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8763,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint453_linear_2723_72924",
    x1: 201.994,
    y1: 123.895,
    x2: 186.897,
    y2: 132.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint454_linear_2723_72924",
    x1: 201.93,
    y1: 123.956,
    x2: 187.258,
    y2: 132.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint455_linear_2723_72924",
    x1: 201.866,
    y1: 124.017,
    x2: 187.62,
    y2: 132.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B0E1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint456_linear_2723_72924",
    x1: 201.801,
    y1: 124.077,
    x2: 187.981,
    y2: 132.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint457_linear_2723_72924",
    x1: 201.736,
    y1: 124.133,
    x2: 188.343,
    y2: 131.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12172C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint458_linear_2723_72924",
    x1: 201.671,
    y1: 124.191,
    x2: 188.705,
    y2: 131.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151C35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1229,
    stopColor: "#12182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint459_linear_2723_72924",
    x1: 201.604,
    y1: 124.248,
    x2: 189.068,
    y2: 131.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19203D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#13182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint460_linear_2723_72924",
    x1: 201.537,
    y1: 124.304,
    x2: 189.431,
    y2: 131.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3257,
    stopColor: "#13182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint461_linear_2723_72924",
    x1: 201.47,
    y1: 124.362,
    x2: 189.794,
    y2: 130.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#202A4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3985,
    stopColor: "#13182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint462_linear_2723_72924",
    x1: 201.402,
    y1: 124.417,
    x2: 190.157,
    y2: 130.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4568,
    stopColor: "#13182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint463_linear_2723_72924",
    x1: 201.334,
    y1: 124.47,
    x2: 190.521,
    y2: 130.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4998,
    stopColor: "#13182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint464_linear_2723_72924",
    x1: 201.265,
    y1: 124.525,
    x2: 190.885,
    y2: 130.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5372,
    stopColor: "#13182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint465_linear_2723_72924",
    x1: 201.196,
    y1: 124.577,
    x2: 191.249,
    y2: 130.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E3C72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5716,
    stopColor: "#13182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint466_linear_2723_72924",
    x1: 201.125,
    y1: 124.625,
    x2: 191.613,
    y2: 129.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32417B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6012,
    stopColor: "#13192E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint467_linear_2723_72924",
    x1: 201.049,
    y1: 124.665,
    x2: 191.971,
    y2: 129.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#364583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624,
    stopColor: "#13182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint468_linear_2723_72924",
    x1: 200.972,
    y1: 124.705,
    x2: 192.331,
    y2: 129.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#394A8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6468,
    stopColor: "#13192E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint469_linear_2723_72924",
    x1: 200.896,
    y1: 124.746,
    x2: 192.691,
    y2: 129.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D4F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6668,
    stopColor: "#13192E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint470_linear_2723_72924",
    x1: 200.82,
    y1: 124.786,
    x2: 193.052,
    y2: 129.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40539E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6847,
    stopColor: "#13182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint471_linear_2723_72924",
    x1: 200.744,
    y1: 124.824,
    x2: 193.414,
    y2: 128.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4458A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0176,
    stopColor: "#4356A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6989,
    stopColor: "#13192E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint472_linear_2723_72924",
    x1: 200.667,
    y1: 124.865,
    x2: 193.776,
    y2: 128.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#475CAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0654,
    stopColor: "#4256A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#13182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint473_linear_2723_72924",
    x1: 200.59,
    y1: 124.902,
    x2: 194.139,
    y2: 128.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B61B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1086,
    stopColor: "#4256A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7267,
    stopColor: "#13192E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint474_linear_2723_72924",
    x1: 196.39,
    y1: 120.55,
    x2: 181.293,
    y2: 129.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint475_linear_2723_72924",
    x1: 196.326,
    y1: 120.611,
    x2: 181.653,
    y2: 129.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint476_linear_2723_72924",
    x1: 196.261,
    y1: 120.671,
    x2: 182.015,
    y2: 128.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B0E1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint477_linear_2723_72924",
    x1: 196.197,
    y1: 120.731,
    x2: 182.377,
    y2: 128.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint478_linear_2723_72924",
    x1: 196.131,
    y1: 120.787,
    x2: 182.738,
    y2: 128.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12172C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint479_linear_2723_72924",
    x1: 196.066,
    y1: 120.847,
    x2: 183.1,
    y2: 128.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151C35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1229,
    stopColor: "#12182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint480_linear_2723_72924",
    x1: 195.999,
    y1: 120.903,
    x2: 183.464,
    y2: 128.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19203D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#13182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint481_linear_2723_72924",
    x1: 195.933,
    y1: 120.96,
    x2: 183.827,
    y2: 127.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3257,
    stopColor: "#13182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint482_linear_2723_72924",
    x1: 195.866,
    y1: 121.017,
    x2: 184.19,
    y2: 127.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#202A4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3985,
    stopColor: "#13182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint483_linear_2723_72924",
    x1: 195.798,
    y1: 121.071,
    x2: 184.553,
    y2: 127.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4568,
    stopColor: "#13182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint484_linear_2723_72924",
    x1: 195.73,
    y1: 121.125,
    x2: 184.916,
    y2: 127.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4998,
    stopColor: "#13182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint485_linear_2723_72924",
    x1: 195.661,
    y1: 121.179,
    x2: 185.281,
    y2: 126.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5372,
    stopColor: "#13182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint486_linear_2723_72924",
    x1: 195.592,
    y1: 121.231,
    x2: 185.645,
    y2: 126.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E3C72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5716,
    stopColor: "#13182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint487_linear_2723_72924",
    x1: 195.521,
    y1: 121.28,
    x2: 186.009,
    y2: 126.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32417B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6012,
    stopColor: "#13192E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint488_linear_2723_72924",
    x1: 195.445,
    y1: 121.319,
    x2: 186.367,
    y2: 126.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#364583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624,
    stopColor: "#13182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint489_linear_2723_72924",
    x1: 195.369,
    y1: 121.36,
    x2: 186.727,
    y2: 126.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#394A8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6468,
    stopColor: "#13192E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint490_linear_2723_72924",
    x1: 195.292,
    y1: 121.4,
    x2: 187.087,
    y2: 125.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D4F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6668,
    stopColor: "#13192E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint491_linear_2723_72924",
    x1: 195.216,
    y1: 121.44,
    x2: 187.448,
    y2: 125.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40539E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6847,
    stopColor: "#13182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint492_linear_2723_72924",
    x1: 195.139,
    y1: 121.478,
    x2: 187.81,
    y2: 125.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4458A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0176,
    stopColor: "#4356A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6989,
    stopColor: "#13192E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint493_linear_2723_72924",
    x1: 195.063,
    y1: 121.519,
    x2: 188.172,
    y2: 125.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#475CAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0654,
    stopColor: "#4256A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#13182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint494_linear_2723_72924",
    x1: 194.986,
    y1: 121.557,
    x2: 188.535,
    y2: 125.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B61B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1086,
    stopColor: "#4256A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7267,
    stopColor: "#13192E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint495_linear_2723_72924",
    x1: 206.932,
    y1: 126.714,
    x2: 191.836,
    y2: 135.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint496_linear_2723_72924",
    x1: 206.868,
    y1: 126.775,
    x2: 192.196,
    y2: 135.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint497_linear_2723_72924",
    x1: 206.804,
    y1: 126.835,
    x2: 192.558,
    y2: 135.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B0E1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint498_linear_2723_72924",
    x1: 206.739,
    y1: 126.894,
    x2: 192.919,
    y2: 134.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint499_linear_2723_72924",
    x1: 206.675,
    y1: 126.952,
    x2: 193.282,
    y2: 134.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12172C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint500_linear_2723_72924",
    x1: 206.609,
    y1: 127.011,
    x2: 193.644,
    y2: 134.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151C35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1229,
    stopColor: "#12182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint501_linear_2723_72924",
    x1: 206.542,
    y1: 127.066,
    x2: 194.007,
    y2: 134.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19203D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#13182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint502_linear_2723_72924",
    x1: 206.476,
    y1: 127.123,
    x2: 194.369,
    y2: 133.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3257,
    stopColor: "#13182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint503_linear_2723_72924",
    x1: 206.409,
    y1: 127.179,
    x2: 194.733,
    y2: 133.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#202A4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3985,
    stopColor: "#13182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint504_linear_2723_72924",
    x1: 206.341,
    y1: 127.234,
    x2: 195.095,
    y2: 133.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4568,
    stopColor: "#13182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint505_linear_2723_72924",
    x1: 206.272,
    y1: 127.287,
    x2: 195.459,
    y2: 133.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4998,
    stopColor: "#13182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint506_linear_2723_72924",
    x1: 206.203,
    y1: 127.342,
    x2: 195.823,
    y2: 133.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5372,
    stopColor: "#13182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint507_linear_2723_72924",
    x1: 206.134,
    y1: 127.393,
    x2: 196.188,
    y2: 132.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E3C72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5716,
    stopColor: "#13182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint508_linear_2723_72924",
    x1: 206.064,
    y1: 127.442,
    x2: 196.551,
    y2: 132.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32417B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6012,
    stopColor: "#13192E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint509_linear_2723_72924",
    x1: 205.987,
    y1: 127.483,
    x2: 196.91,
    y2: 132.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#364583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624,
    stopColor: "#13182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint510_linear_2723_72924",
    x1: 205.911,
    y1: 127.522,
    x2: 197.269,
    y2: 132.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#394A8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6468,
    stopColor: "#13192E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint511_linear_2723_72924",
    x1: 205.834,
    y1: 127.564,
    x2: 197.629,
    y2: 132.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D4F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6668,
    stopColor: "#13192E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint512_linear_2723_72924",
    x1: 205.759,
    y1: 127.602,
    x2: 197.991,
    y2: 131.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40539E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6847,
    stopColor: "#13182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint513_linear_2723_72924",
    x1: 205.682,
    y1: 127.642,
    x2: 198.352,
    y2: 131.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4458A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0176,
    stopColor: "#4356A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6989,
    stopColor: "#13192E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint514_linear_2723_72924",
    x1: 205.605,
    y1: 127.681,
    x2: 198.714,
    y2: 131.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#475CAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0654,
    stopColor: "#4256A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7135,
    stopColor: "#13182E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint515_linear_2723_72924",
    x1: 205.529,
    y1: 127.721,
    x2: 199.077,
    y2: 131.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B61B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1086,
    stopColor: "#4256A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7267,
    stopColor: "#13192E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentAnalystUseCase);
export default __webpack_public_path__ + "static/media/agent-analyst-use-case.0f968dbd17e50593f066d2172f0488cc.svg";
export { ForwardRef as ReactComponent };